import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: any;
  File: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export enum AdminAnalyticsChartType {
  LinkClicks = 'LinkClicks',
  NewUser = 'NewUser',
  PageViews = 'PageViews',
  SingleLinkClicks = 'SingleLinkClicks',
  UserActivity = 'UserActivity'
}

export type AdminAuth = {
  __typename?: 'AdminAuth';
  /** JWT access token */
  accessToken: Scalars['String'];
  /** JWT refresh token */
  refreshToken: Scalars['String'];
};

export type AdminLoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AdminModel = {
  __typename?: 'AdminModel';
  email: Scalars['String'];
};

export type AdminQrLinkModel = {
  __typename?: 'AdminQrLinkModel';
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  owner: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
  url: Scalars['String'];
};

export type AdminSignupInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export enum AgeType {
  A18 = 'a18',
  A21 = 'a21',
  A25 = 'a25',
  Sensitive = 'sensitive'
}

export type AnalyticEvent = {
  clickTime?: InputMaybe<Scalars['Int']>;
  name: AnalyticEventType;
  qrUtm?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  targetId: Scalars['String'];
};

export type AnalyticEventInput = {
  browserId: Scalars['String'];
  eventPayload: AnalyticEvent;
};

export enum AnalyticEventType {
  PageLinkClick = 'PageLinkClick',
  PageView = 'PageView'
}

export type Analytics = {
  __typename?: 'Analytics';
  fb?: Maybe<Scalars['String']>;
  google?: Maybe<Scalars['String']>;
  utmCodes?: Maybe<UtmCodesModel>;
};

export type AnalyticsInput = {
  fb?: InputMaybe<Scalars['String']>;
  google?: InputMaybe<Scalars['String']>;
  utmCodes?: InputMaybe<UtmCodesInput>;
};

export type AppearanceInput = {
  bio?: InputMaybe<PageBioInput>;
  buttons?: InputMaybe<PageButtonInput>;
  font?: InputMaybe<PageFontInput>;
  logo?: InputMaybe<Scalars['Boolean']>;
  profileImage?: InputMaybe<Scalars['String']>;
  social?: InputMaybe<PageSocialIconsInput>;
  theme?: InputMaybe<PageThemeInput>;
  title?: InputMaybe<PageTitleInput>;
};

export type AppearanceModel = {
  __typename?: 'AppearanceModel';
  bio: PageBioModel;
  buttons?: Maybe<PageButtonModel>;
  colors: Array<Scalars['String']>;
  font: PageFontModel;
  logo: Scalars['Boolean'];
  profileImage?: Maybe<Scalars['String']>;
  social?: Maybe<PageSocialIconsModel>;
  theme: PageThemeModel;
  title: PageTitleModel;
};

export type Auth = {
  __typename?: 'Auth';
  /** JWT access token */
  accessToken: Scalars['String'];
  /** JWT refresh token */
  refreshToken: Scalars['String'];
  user: Customer;
};

export type AuthDefaultPlanSettingsModel = {
  __typename?: 'AuthDefaultPlanSettingsModel';
  defaultPlanName: SubscriptionPlan;
  duration: Scalars['Int'];
};

export type AuthSettingsDefaultPlanInput = {
  defaultPlanName?: Scalars['String'];
  duration?: Scalars['Int'];
};

export type AuthSettingsModel = {
  __typename?: 'AuthSettingsModel';
  defaultPlan: AuthDefaultPlanSettingsModel;
};

export type BlockEmailInput = {
  email: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};

export type BlockedEmailModel = {
  __typename?: 'BlockedEmailModel';
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  reason: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ChangePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type ChartData = {
  __typename?: 'ChartData';
  city?: Maybe<Scalars['String']>;
  count: Scalars['Float'];
  country?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  day?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
  os?: Maybe<Scalars['String']>;
  part?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ChartModel = {
  __typename?: 'ChartModel';
  count: Scalars['Int'];
  day: Scalars['String'];
};

export type Children = {
  __typename?: 'Children';
  row: Array<LinkModel>;
  rowId: Scalars['String'];
};

export enum ColorType {
  Flat = 'Flat',
  GradientDown = 'GradientDown',
  GradientUp = 'GradientUp',
  LinearGradient = 'LinearGradient',
  RadialGradient = 'RadialGradient'
}

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateDomainInput = {
  domain: Scalars['String'];
  errorPage?: InputMaybe<Scalars['String']>;
};

export type CreateEmailSubscriber = {
  email: Scalars['String'];
  page: Scalars['String'];
};

export type CreatePromocodeInput = {
  expiration?: InputMaybe<Scalars['Date']>;
  maxCustomer?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type CreateRandomPromocodeInput = {
  count: Scalars['Int'];
  expiration?: InputMaybe<Scalars['Date']>;
  lenght: Scalars['Int'];
  maxCustomer?: InputMaybe<Scalars['Int']>;
  prefix?: InputMaybe<Scalars['String']>;
};

export type CreateSmsSubscriber = {
  page: Scalars['String'];
  phone: Scalars['String'];
};

export type CustomDashboard = {
  __typename?: 'CustomDashboard';
  id: Scalars['String'];
  reports: Array<CustomDashboardReport>;
  title: Scalars['String'];
};

export type CustomDashboardEvent = {
  __typename?: 'CustomDashboardEvent';
  id: Scalars['String'];
  title: Scalars['String'];
};

export type CustomDashboardEvents = {
  __typename?: 'CustomDashboardEvents';
  linkClicks: Array<CustomDashboardEvent>;
  pageViews: Array<CustomDashboardEvent>;
  qrScans: Array<CustomDashboardEvent>;
  socialLinkClicks: Array<CustomDashboardEvent>;
  targetScans: Array<CustomDashboardEvent>;
};

export type CustomDashboardReport = {
  __typename?: 'CustomDashboardReport';
  config: Scalars['JSONObject'];
  id: Scalars['String'];
  series: Array<MetricSeries>;
  title: Scalars['String'];
};

export type CustomReportInput = {
  analyticsDashboardId: Scalars['String'];
  config: Scalars['JSONObject'];
  id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CustomReportUpdatePositionInput = {
  id?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
};

export type Customer = {
  __typename?: 'Customer';
  active: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  blocked: Scalars['Boolean'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  customerPagesCount: Scalars['Int'];
  customerPagesList: Scalars['JSONObject'];
  customerPagesListAdmin: Array<Scalars['String']>;
  deleteTime?: Maybe<Scalars['Date']>;
  deleted: Scalars['Boolean'];
  email: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integrations: Array<Integration>;
  page: PageModel;
  selectedFeature: SelectedFeature;
  subscriptionPlan: CustomerSubscription;
  timezone?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
  username: Scalars['String'];
};

export type CustomerSubscription = {
  __typename?: 'CustomerSubscription';
  canTrial: Scalars['Boolean'];
  currency: Scalars['String'];
  end_date?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  name: SubscriptionPlan;
  price: Scalars['Int'];
  price_id?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stripeCustomerId: Scalars['String'];
};

export type DateInterval = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type DeleteEmailSubscriber = {
  emails: Array<Scalars['String']>;
};

export type DeleteLinkInput = {
  id: Scalars['String'];
};

export type DomainModel = {
  __typename?: 'DomainModel';
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  domain: Scalars['String'];
  errorPage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
  usedInPage?: Maybe<Scalars['String']>;
};

export enum EmailProviders {
  Google = 'google',
  Joyqr = 'joyqr',
  Mailchimp = 'mailchimp'
}

export type EmailSignup = {
  __typename?: 'EmailSignup';
  buttonText: Scalars['String'];
  colors?: Maybe<SubscriberSignupColorsModel>;
  googleSheetUrl?: Maybe<Scalars['String']>;
  mailchimpApi?: Maybe<Scalars['String']>;
  mailchimpList?: Maybe<Scalars['String']>;
  position: Position;
  storage?: Maybe<EmailProviders>;
  successMessage: Scalars['String'];
  terms?: Maybe<Terms>;
};

export type EmailSignupInput = {
  buttonText?: Scalars['String'];
  colors?: InputMaybe<SubscriberSignupColorsInput>;
  googleSheetUrl?: InputMaybe<Scalars['String']>;
  mailchimpApi?: InputMaybe<Scalars['String']>;
  mailchimpList?: InputMaybe<Scalars['String']>;
  position?: Position;
  storage?: InputMaybe<EmailProviders>;
  successMessage?: Scalars['String'];
  terms?: InputMaybe<TermsInput>;
};

export type Eye = {
  id?: InputMaybe<Scalars['Int']>;
  lB: EyeColor;
  lT: EyeColor;
  rT: EyeColor;
  type?: InputMaybe<ColorType>;
};

export type EyeColor = {
  external: Scalars['String'];
  externalId: Scalars['Int'];
  internal: Scalars['String'];
  internalId: Scalars['Int'];
};

export type EyeColorModel = {
  __typename?: 'EyeColorModel';
  external: Scalars['String'];
  externalId: Scalars['Int'];
  internal: Scalars['String'];
  internalId: Scalars['Int'];
};

export type EyeModel = {
  __typename?: 'EyeModel';
  /** @deprecated  moved to lT,rT,lB */
  id: Scalars['Int'];
  lB: EyeColorModel;
  lT: EyeColorModel;
  rT: EyeColorModel;
  /** @deprecated moved to lT,rT,lB */
  type: ColorType;
};

export type GradientColorInput = {
  angle?: Scalars['Int'];
  firstColor: Scalars['String'];
  secondColor: Scalars['String'];
  type: ColorType;
};

export type GradientColorModel = {
  __typename?: 'GradientColorModel';
  angle: Scalars['Int'];
  firstColor: Scalars['String'];
  secondColor: Scalars['String'];
  type: ColorType;
};

export type GroupByFilter = {
  group: Scalars['String'];
};

export type InfoBanner = {
  __typename?: 'InfoBanner';
  buttonLabel: Scalars['String'];
  buttonUrl: Scalars['String'];
  colors?: Maybe<InfoBannerColors>;
  content: Scalars['String'];
  font: Scalars['String'];
  title: Scalars['String'];
};

export type InfoBannerColors = {
  __typename?: 'InfoBannerColors';
  background: Scalars['String'];
  buttonBg: Scalars['String'];
  buttonLabel: Scalars['String'];
  content: Scalars['String'];
  title: Scalars['String'];
};

export type InfoBannerColorsInput = {
  background?: Scalars['String'];
  buttonBg?: Scalars['String'];
  buttonLabel?: Scalars['String'];
  content?: Scalars['String'];
  title?: Scalars['String'];
};

export type InfoBannerInput = {
  buttonLabel?: Scalars['String'];
  buttonUrl?: Scalars['String'];
  colors?: InputMaybe<InfoBannerColorsInput>;
  content?: Scalars['String'];
  font?: Scalars['String'];
  title: Scalars['String'];
};

export enum InsightDataQuery {
  BioOverview = 'BioOverview',
  LinkClicks = 'LinkClicks',
  PageViews = 'PageViews',
  QrByMonth = 'QrByMonth',
  QrOverview = 'QrOverview',
  QrScans = 'QrScans',
  TopBioViewDevices = 'TopBioViewDevices',
  TopBioViewLocations = 'TopBioViewLocations',
  TopBioViewOs = 'TopBioViewOs',
  TopBioViewRefferers = 'TopBioViewRefferers',
  TopLinks = 'TopLinks',
  TopQr = 'TopQr',
  TopQrByDay = 'TopQrByDay',
  TopQrByHour = 'TopQrByHour',
  TopQrDevices = 'TopQrDevices',
  TopQrLocations = 'TopQrLocations',
  TopQrOs = 'TopQrOs'
}

export type InsightReport = {
  __typename?: 'InsightReport';
  config: Scalars['JSONObject'];
  id: Scalars['String'];
  series: Array<MetricSeries>;
};

export enum InsightType {
  Bio = 'Bio',
  Qr = 'Qr'
}

export type InstagramPostModel = {
  __typename?: 'InstagramPostModel';
  id: Scalars['String'];
  media_url: Scalars['String'];
};

export type InstagramResponseModel = {
  __typename?: 'InstagramResponseModel';
  data: Array<InstagramPostModel>;
  next?: Maybe<Scalars['String']>;
};

export type Integration = {
  __typename?: 'Integration';
  provider: IntegrationProvider;
  userId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export enum IntegrationProvider {
  Google = 'google',
  Instagram = 'instagram',
  Mailchimp = 'mailchimp'
}

export type Interval = {
  __typename?: 'Interval';
  clicks: Scalars['Int'];
  views: Scalars['Int'];
};

export enum JoyqrStatPeriodType {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export type LinkModel = {
  __typename?: 'LinkModel';
  childRow: Scalars['Int'];
  children: Array<Children>;
  clicks?: Maybe<Scalars['Int']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  embeded: Scalars['Boolean'];
  embededIframe?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isLinkValid?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  leapTime: Scalars['Int'];
  order: Scalars['Int'];
  priority: Scalars['Int'];
  scheduleEnd?: Maybe<Scalars['String']>;
  scheduleStart?: Maybe<Scalars['String']>;
  scheduleTimezone?: Maybe<Scalars['String']>;
  settings?: Maybe<LinkSettings>;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: LinkType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
  url: Scalars['String'];
  urlHolder?: Maybe<Scalars['String']>;
};

export type LinkSettings = {
  __typename?: 'LinkSettings';
  row: Scalars['Int'];
};

export enum LinkType {
  Button = 'Button',
  DropdownButton = 'DropdownButton',
  Embeded = 'Embeded',
  Grid = 'Grid',
  ImageButton = 'ImageButton',
  SocialIcon = 'SocialIcon'
}

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Meta = {
  __typename?: 'Meta';
  count: Scalars['Int'];
};

export type MetricSeries = {
  __typename?: 'MetricSeries';
  metricId: Scalars['Int'];
  serie: Array<ChartData>;
};

export type Module = {
  color: GradientColorInput;
  id: Scalars['Int'];
};

export type ModuleModel = {
  __typename?: 'ModuleModel';
  color: GradientColorModel;
  id: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  adminLogin: AdminAuth;
  adminSignup: Scalars['String'];
  analyticEvent: Scalars['String'];
  applyPromoCode: Scalars['String'];
  blockEmail: Scalars['String'];
  cancelDelete: Scalars['Boolean'];
  cancelSubscription: Scalars['JSONObject'];
  changeBlockState: Customer;
  changePassword: Customer;
  confirmEmail: Scalars['String'];
  createCustomDashboard: CustomDashboard;
  createCustomReport: CustomDashboardReport;
  createDomain: DomainModel;
  createEmailSubscriber: Scalars['String'];
  createGridLinks: Array<LinkModel>;
  createPage: PageModel;
  createPageLink: LinkModel;
  createPromocode: PromoCodeModel;
  createQr: QrModel;
  createQrTag: Scalars['String'];
  createQrTemplate: QrTemplateModel;
  createRandomPromocodes: Scalars['Int'];
  createSingleLinkCategory: SingleLinkCategoryModel;
  createSingleLinkTarget: SingleLinkTargetModel;
  createSmsSubscriber: Scalars['String'];
  deleteBioLink: Scalars['Boolean'];
  deleteCategory: Scalars['String'];
  deleteDashboard: Scalars['String'];
  deleteDomain: Scalars['String'];
  deleteEmailSubscriber: Scalars['String'];
  deleteLink: LinkModel;
  deleteMe: Scalars['Boolean'];
  deletePage: Scalars['String'];
  deleteQrCode: Scalars['Boolean'];
  deleteQrTag: Array<Scalars['String']>;
  deleteQrTemplate: Scalars['Boolean'];
  deleteReport: Scalars['String'];
  deleteSingleLink: Scalars['String'];
  deleteUser: Scalars['Boolean'];
  forgotPassword: Scalars['String'];
  login: Auth;
  oauth: Scalars['String'];
  refreshToken: Token;
  removeSingleLinkFromCategory: SingleLinkModel;
  resendActivationMail: Scalars['String'];
  resetPassword: Scalars['String'];
  selectFeature: SelectedFeature;
  selectPage: PageModel;
  signup: Auth;
  updateAppearance: AppearanceModel;
  updateDashboardGrid: Scalars['String'];
  updateDashboardName: Scalars['String'];
  updateDefaultPlanSetting: AuthDefaultPlanSettingsModel;
  updateLink: LinkModel;
  updateLinkModifier: LinkModel;
  updateLinksOrder: Array<LinkModel>;
  updatePageDomain?: Maybe<DomainModel>;
  updatePromocode: PromoCodeModel;
  updateSettings: PageSettingsModel;
  updateSingleLink: SingleLinkModel;
  updateSingleLinkCategory: SingleLinkCategoryModel;
  updateSubscriptionAdmin: Scalars['String'];
  updateUser: Customer;
};


export type MutationAdminLoginArgs = {
  data: AdminLoginInput;
};


export type MutationAdminSignupArgs = {
  data: AdminSignupInput;
};


export type MutationAnalyticEventArgs = {
  data: AnalyticEventInput;
};


export type MutationApplyPromoCodeArgs = {
  data: Scalars['String'];
};


export type MutationBlockEmailArgs = {
  data: BlockEmailInput;
};


export type MutationChangeBlockStateArgs = {
  userId: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  data: ChangePasswordInput;
};


export type MutationConfirmEmailArgs = {
  token: Scalars['String'];
};


export type MutationCreateCustomDashboardArgs = {
  name: Scalars['String'];
};


export type MutationCreateCustomReportArgs = {
  data: CustomReportInput;
};


export type MutationCreateDomainArgs = {
  data: CreateDomainInput;
};


export type MutationCreateEmailSubscriberArgs = {
  data: CreateEmailSubscriber;
};


export type MutationCreateGridLinksArgs = {
  count?: InputMaybe<Scalars['Int']>;
  parent?: InputMaybe<Scalars['String']>;
};


export type MutationCreatePageArgs = {
  pagename: Scalars['String'];
};


export type MutationCreatePageLinkArgs = {
  parent?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LinkType>;
};


export type MutationCreatePromocodeArgs = {
  data: CreatePromocodeInput;
};


export type MutationCreateQrArgs = {
  data: QrInput;
};


export type MutationCreateQrTagArgs = {
  tag: Scalars['String'];
};


export type MutationCreateQrTemplateArgs = {
  data: QrTemplateInput;
};


export type MutationCreateRandomPromocodesArgs = {
  data: CreateRandomPromocodeInput;
};


export type MutationCreateSingleLinkCategoryArgs = {
  data: SingleLinkCategoryInput;
};


export type MutationCreateSingleLinkTargetArgs = {
  data: SingleLinkTargetInput;
};


export type MutationCreateSmsSubscriberArgs = {
  data: CreateSmsSubscriber;
};


export type MutationDeleteBioLinkArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDashboardArgs = {
  dashboardId: Scalars['String'];
};


export type MutationDeleteDomainArgs = {
  domainId: Scalars['String'];
};


export type MutationDeleteEmailSubscriberArgs = {
  data: DeleteEmailSubscriber;
};


export type MutationDeleteLinkArgs = {
  data: DeleteLinkInput;
};


export type MutationDeletePageArgs = {
  pageId: Scalars['String'];
};


export type MutationDeleteQrCodeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteQrTagArgs = {
  tag: Scalars['String'];
};


export type MutationDeleteQrTemplateArgs = {
  id: Scalars['String'];
};


export type MutationDeleteReportArgs = {
  reportId: Scalars['String'];
};


export type MutationDeleteSingleLinkArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationOauthArgs = {
  data: OAuthInput;
};


export type MutationRefreshTokenArgs = {
  token: Scalars['String'];
};


export type MutationRemoveSingleLinkFromCategoryArgs = {
  id: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSelectFeatureArgs = {
  feature: SelectedFeature;
};


export type MutationSelectPageArgs = {
  pageId: Scalars['String'];
};


export type MutationSignupArgs = {
  data: SignupInput;
};


export type MutationUpdateAppearanceArgs = {
  data: AppearanceInput;
};


export type MutationUpdateDashboardGridArgs = {
  dashboardId: Scalars['String'];
  data: Array<CustomReportUpdatePositionInput>;
};


export type MutationUpdateDashboardNameArgs = {
  dashboardId: Scalars['String'];
  dashboardName: Scalars['String'];
};


export type MutationUpdateDefaultPlanSettingArgs = {
  data: AuthSettingsDefaultPlanInput;
};


export type MutationUpdateLinkArgs = {
  data: UpdateLinkInput;
};


export type MutationUpdateLinkModifierArgs = {
  data: UpdateLinkModifier;
};


export type MutationUpdateLinksOrderArgs = {
  data: Array<UpdateLinkInputOrder>;
};


export type MutationUpdatePageDomainArgs = {
  domainId?: InputMaybe<Scalars['String']>;
  pageId: Scalars['String'];
};


export type MutationUpdatePromocodeArgs = {
  data: UpdatePromocodeInput;
};


export type MutationUpdateSettingsArgs = {
  data: PageSettingsInput;
};


export type MutationUpdateSingleLinkArgs = {
  data?: InputMaybe<SingleLinkInput>;
};


export type MutationUpdateSingleLinkCategoryArgs = {
  data: SingleLinkCategoryUpdate;
};


export type MutationUpdateSubscriptionAdminArgs = {
  data: UpdateCustomerSubscription;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};

export type OAuthInput = {
  authCode: Scalars['String'];
  service: Scalars['String'];
};

export type PageBioInput = {
  color: Scalars['String'];
  font: Scalars['String'];
  fontSize: Scalars['Int'];
  value: Scalars['String'];
};

export type PageBioModel = {
  __typename?: 'PageBioModel';
  color: Scalars['String'];
  font: Scalars['String'];
  fontSize: Scalars['Int'];
  value: Scalars['String'];
};

export type PageButtonInput = {
  custom?: InputMaybe<PageCustomButtonInput>;
  id: Scalars['String'];
};

export type PageButtonModel = {
  __typename?: 'PageButtonModel';
  custom?: Maybe<PageCustomButtonModel>;
  id: Scalars['String'];
};

export type PageCustomButtonColorInput = {
  bgColor: Scalars['String'];
  hoverColor: Scalars['String'];
  shadowColor: Scalars['String'];
  textColor: Scalars['String'];
};

export type PageCustomButtonColorModel = {
  __typename?: 'PageCustomButtonColorModel';
  bgColor: Scalars['String'];
  hoverColor: Scalars['String'];
  shadowColor: Scalars['String'];
  textColor: Scalars['String'];
};

export type PageCustomButtonInput = {
  color: PageCustomButtonColorInput;
  stroke?: InputMaybe<PageCustomButtonStrokeInput>;
};

export type PageCustomButtonModel = {
  __typename?: 'PageCustomButtonModel';
  color: PageCustomButtonColorModel;
  stroke?: Maybe<PageCustomButtonStrokeModel>;
};

export type PageCustomButtonStrokeInput = {
  color: Scalars['String'];
  width: Scalars['Int'];
};

export type PageCustomButtonStrokeModel = {
  __typename?: 'PageCustomButtonStrokeModel';
  color: Scalars['String'];
  width: Scalars['Int'];
};

export type PageCustomThemeInput = {
  bgFilter?: InputMaybe<Scalars['String']>;
  bgImage?: InputMaybe<Scalars['String']>;
  color: GradientColorInput;
};

export type PageCustomThemeModel = {
  __typename?: 'PageCustomThemeModel';
  bgFilter?: Maybe<Scalars['String']>;
  bgImage?: Maybe<Scalars['String']>;
  color: GradientColorModel;
};

export type PageFontInput = {
  family: Scalars['String'];
  id: Scalars['Int'];
  size: Scalars['Int'];
};

export type PageFontModel = {
  __typename?: 'PageFontModel';
  family: Scalars['String'];
  id: Scalars['Int'];
  size: Scalars['Int'];
};

export type PageModel = {
  __typename?: 'PageModel';
  appearance: AppearanceModel;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  domain?: Maybe<DomainModel>;
  domainId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** List of links */
  links: Array<LinkModel>;
  pagename: Scalars['String'];
  qr: QrModel;
  settings: PageSettingsModel;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
};

export type PageSettingsInput = {
  analytics?: InputMaybe<AnalyticsInput>;
  contact?: InputMaybe<ContactInput>;
  emailSignup?: InputMaybe<EmailSignupInput>;
  favicon?: InputMaybe<Scalars['String']>;
  infoBanner?: InputMaybe<InfoBannerInput>;
  sensitive?: InputMaybe<SensitiveMaterialInput>;
  seo?: InputMaybe<SeoInput>;
  smsSignup?: InputMaybe<SmsSignupInput>;
};

export type PageSettingsModel = {
  __typename?: 'PageSettingsModel';
  analytics: Analytics;
  contact?: Maybe<Contact>;
  emailSignup?: Maybe<EmailSignup>;
  favicon?: Maybe<Scalars['String']>;
  infoBanner?: Maybe<InfoBanner>;
  sensitive?: Maybe<SensitiveMaterial>;
  seo?: Maybe<Seo>;
  smsSignup?: Maybe<SmsSignup>;
};

export type PageSocialIconsInput = {
  iconsColor: Scalars['String'];
};

export type PageSocialIconsModel = {
  __typename?: 'PageSocialIconsModel';
  /** @deprecated DEPRECATED */
  buttonIconsColor?: Maybe<Scalars['String']>;
  /** @deprecated DEPRECATED */
  icons?: Maybe<Array<SocialLink>>;
  iconsColor: Scalars['String'];
};

export type PageThemeInput = {
  custom?: InputMaybe<PageCustomThemeInput>;
  id: Scalars['String'];
};

export type PageThemeModel = {
  __typename?: 'PageThemeModel';
  custom?: Maybe<PageCustomThemeModel>;
  id: Scalars['String'];
};

export type PageTitleInput = {
  color: Scalars['String'];
  font: Scalars['String'];
  fontSize: Scalars['Int'];
  value: Scalars['String'];
};

export type PageTitleModel = {
  __typename?: 'PageTitleModel';
  color: Scalars['String'];
  font: Scalars['String'];
  fontSize: Scalars['Int'];
  value: Scalars['String'];
};

export type PaginatedLinks = {
  __typename?: 'PaginatedLinks';
  nodes: Array<SingleLinkModel>;
  totalCount: Scalars['Int'];
};

export enum Position {
  Bottom = 'bottom',
  Middle = 'middle',
  Top = 'top'
}

export type PromoCodeModel = {
  __typename?: 'PromoCodeModel';
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  customer?: Maybe<Customer>;
  expiration?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  maxCustomer: Scalars['Int'];
  numberUses: Scalars['Int'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
  value: Scalars['String'];
};

export type QrCusomFrameModel = {
  __typename?: 'QrCusomFrameModel';
  frameColor1: Scalars['String'];
  frameColor2: Scalars['String'];
  frameColorAngle: Scalars['Int'];
  frameColorType: ColorType;
  label: Scalars['String'];
  labelColor: Scalars['String'];
  labelSize: Scalars['Int'];
  type: Scalars['String'];
};

export type QrCustomFrameInput = {
  frameColor1: Scalars['String'];
  frameColor2: Scalars['String'];
  frameColorAngle: Scalars['Int'];
  frameColorType?: ColorType;
  label: Scalars['String'];
  labelColor: Scalars['String'];
  labelSize: Scalars['Int'];
  type: Scalars['String'];
};

export type QrFrameInput = {
  custom?: InputMaybe<QrCustomFrameInput>;
  id: Scalars['Int'];
};

export type QrFrameModel = {
  __typename?: 'QrFrameModel';
  custom?: Maybe<QrCusomFrameModel>;
  id: Scalars['Int'];
};

export type QrInput = {
  _logo?: InputMaybe<QrLogoInput>;
  eyes: Eye;
  frame: QrFrameInput;
  joyLogo?: InputMaybe<Scalars['Boolean']>;
  module: Module;
  padding?: Scalars['Float'];
  shape: QrShapeInput;
  title?: InputMaybe<QrTitle>;
};

export type QrLogoInput = {
  hideBg: Scalars['Boolean'];
  margin: Scalars['Float'];
  size: Scalars['Float'];
  thumbnail: Scalars['String'];
};

export type QrLogoModel = {
  __typename?: 'QrLogoModel';
  hideBg: Scalars['Boolean'];
  margin: Scalars['Float'];
  size: Scalars['Float'];
  thumbnail: Scalars['String'];
};

export type QrModel = {
  __typename?: 'QrModel';
  _logo?: Maybe<QrLogoModel>;
  bgColor: GradientColorModel;
  copyText: Scalars['Boolean'];
  eyes: EyeModel;
  files: Array<Maybe<Scalars['File']>>;
  frame: QrFrameModel;
  joyLogo: Scalars['Boolean'];
  /** @deprecated New _logo  */
  logo?: Maybe<Scalars['String']>;
  module: ModuleModel;
  padding: Scalars['Float'];
  shape: QrShapeModel;
  tags: Array<Scalars['String']>;
  title?: Maybe<QrModelTitle>;
};

export type QrModelTitle = {
  __typename?: 'QrModelTitle';
  color: Scalars['String'];
  font?: Maybe<Scalars['String']>;
  fontSize: Scalars['Int'];
  text: Scalars['String'];
};

export type QrShapeInput = {
  bgColor: GradientColorInput;
  bgSize: Scalars['Int'];
  stroke: Scalars['Int'];
  strokeColor: GradientColorInput;
  type: Scalars['String'];
};

export type QrShapeModel = {
  __typename?: 'QrShapeModel';
  bgColor: GradientColorModel;
  bgSize: Scalars['Int'];
  stroke: Scalars['Int'];
  strokeColor: GradientColorModel;
  type: Scalars['String'];
};

export type QrSingleLinkInput = {
  _logo?: InputMaybe<QrLogoInput>;
  copyText?: Scalars['Boolean'];
  eyes: Eye;
  frame: QrFrameInput;
  joyLogo?: InputMaybe<Scalars['Boolean']>;
  module: Module;
  padding?: Scalars['Float'];
  shape: QrShapeInput;
  title?: InputMaybe<QrTitle>;
};

export type QrSingleLinkModel = {
  __typename?: 'QrSingleLinkModel';
  files: Array<Maybe<Scalars['File']>>;
};

export type QrTemplateInput = {
  appearance: Scalars['JSONObject'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type QrTemplateModel = {
  __typename?: 'QrTemplateModel';
  appearance: Scalars['JSONObject'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type QrTitle = {
  color: Scalars['String'];
  font?: InputMaybe<Scalars['String']>;
  fontSize: Scalars['Int'];
  text: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  allCustomers: Array<Customer>;
  allPromocodes: Array<PromoCodeModel>;
  blockedEmails: Array<BlockedEmailModel>;
  categories: Array<SingleLinkCategoryModel>;
  category: SingleLinkCategoryModel;
  chartData: Array<ChartModel>;
  checkUsername: Scalars['Boolean'];
  createTmpSingleLink: SingleLinkModel;
  customDashboardEvents: CustomDashboardEvents;
  customDashboards: Array<CustomDashboard>;
  customDomains: Array<DomainModel>;
  customer: Customer;
  dashboard: CustomDashboard;
  deletingCustomers: Array<Customer>;
  embeded?: Maybe<Scalars['String']>;
  eventData: Array<ChartData>;
  filters: Array<Scalars['String']>;
  getBioLinks: Array<AdminQrLinkModel>;
  getBioLinksCount: Scalars['Int'];
  getCountOfCodes: Scalars['Int'];
  getCountOfCustomers: Scalars['Int'];
  getQrCodes: Array<AdminQrLinkModel>;
  getQrCodesCount: Scalars['Int'];
  getSettings: SettingsModel;
  getSingleLink: SingleLinkModel;
  getSingleLinks: PaginatedLinks;
  getUnsplashPhotos?: Maybe<Array<UnsplashPhoto>>;
  insight: InsightReport;
  instagramPosts: InstagramResponseModel;
  mailchimpLists: Scalars['JSONObject'];
  me: Customer;
  meAdmin: AdminModel;
  page: PageModel;
  promocode: PromoCodeModel;
  qrTemplates: Array<QrTemplateModel>;
  report: CustomDashboardReport;
  searchBioLinks: Array<AdminQrLinkModel>;
  searchCustomer: Array<Customer>;
  searchQrCodes: Array<AdminQrLinkModel>;
  singleLinkTargets: SingleLinkTargetsModel;
  snapshotCharts: Array<Array<ChartModel>>;
  subscribers: SubscriberModel;
  topThreeStats: TopThree;
  weekStats: WeekNumbers;
};


export type QueryAllCustomersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllPromocodesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoryArgs = {
  id: Scalars['String'];
};


export type QueryChartDataArgs = {
  period: JoyqrStatPeriodType;
  type: AdminAnalyticsChartType;
};


export type QueryCheckUsernameArgs = {
  username: Scalars['String'];
};


export type QueryCustomerArgs = {
  username: Scalars['String'];
};


export type QueryDashboardArgs = {
  dashboardId: Scalars['String'];
};


export type QueryEmbededArgs = {
  url: Scalars['String'];
};


export type QueryEventDataArgs = {
  date: DateInterval;
  event: Scalars['String'];
  filters?: InputMaybe<Array<QueryFilter>>;
  groupBy?: InputMaybe<Array<GroupByFilter>>;
  itemId: Scalars['String'];
  type: Scalars['String'];
};


export type QueryFiltersArgs = {
  filter: Scalars['String'];
};


export type QueryGetBioLinksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetQrCodesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetSingleLinkArgs = {
  id: Scalars['String'];
};


export type QueryGetSingleLinksArgs = {
  category?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetUnsplashPhotosArgs = {
  search: Scalars['String'];
};


export type QueryInsightArgs = {
  date?: InputMaybe<DateInterval>;
  id?: InputMaybe<Scalars['String']>;
  query?: InsightDataQuery;
  type?: InsightType;
};


export type QueryInstagramPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
};


export type QueryMailchimpListsArgs = {
  api: Scalars['String'];
};


export type QueryPageArgs = {
  pagename: Scalars['String'];
};


export type QueryPromocodeArgs = {
  code: Scalars['String'];
};


export type QueryReportArgs = {
  reportId: Scalars['String'];
};


export type QuerySearchBioLinksArgs = {
  search: Scalars['String'];
};


export type QuerySearchCustomerArgs = {
  search: Scalars['String'];
};


export type QuerySearchQrCodesArgs = {
  search: Scalars['String'];
};


export type QuerySnapshotChartsArgs = {
  period?: JoyqrStatPeriodType;
};


export type QuerySubscribersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  type?: Scalars['String'];
};

export type QueryFilter = {
  condition: Scalars['String'];
  filter: Scalars['String'];
  values: Array<Scalars['String']>;
};

export enum SelectedFeature {
  BioLink = 'BioLink',
  None = 'None',
  SingleLink = 'SingleLink'
}

export type SensitiveMaterial = {
  __typename?: 'SensitiveMaterial';
  type: AgeType;
};

export type SensitiveMaterialInput = {
  type: AgeType;
};

export type Seo = {
  __typename?: 'Seo';
  description: Scalars['String'];
  title: Scalars['String'];
};

export type SeoInput = {
  description?: Scalars['String'];
  title?: Scalars['String'];
};

export type SettingsModel = {
  __typename?: 'SettingsModel';
  authSettings: AuthSettingsModel;
};

export type SignupInput = {
  email: Scalars['String'];
  newsletter: Scalars['Boolean'];
  password: Scalars['String'];
  promo?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type SingleLinkCategoryInput = {
  name: Scalars['String'];
};

export type SingleLinkCategoryModel = {
  __typename?: 'SingleLinkCategoryModel';
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  links: Array<SingleLinkModel>;
  linksCount: Scalars['Int'];
  name: Scalars['String'];
  scans: Scalars['Int'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SingleLinkCategoryUpdate = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SingleLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  domainId?: InputMaybe<Scalars['String']>;
  hash: Scalars['String'];
  id: Scalars['String'];
  isPassive?: Scalars['Boolean'];
  password?: InputMaybe<Scalars['String']>;
  qr?: InputMaybe<QrSingleLinkInput>;
  singleLinkCategoryId?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<SingleLinkQrTargetInput>;
  title?: InputMaybe<Scalars['String']>;
  type: SingleLinkType;
  url: Scalars['String'];
};

export type SingleLinkModel = {
  __typename?: 'SingleLinkModel';
  categoryName?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  domainId?: Maybe<Scalars['String']>;
  hash: Scalars['String'];
  id: Scalars['String'];
  isPassive: Scalars['Boolean'];
  password?: Maybe<Scalars['String']>;
  qr?: Maybe<QrModel>;
  scans?: Maybe<Scalars['Int']>;
  singleLinkCategoryId?: Maybe<Scalars['String']>;
  target?: Maybe<SingleLinkQrTarget>;
  title?: Maybe<Scalars['String']>;
  type: SingleLinkType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
  url?: Maybe<Scalars['String']>;
};

export type SingleLinkQrTarget = {
  __typename?: 'SingleLinkQrTarget';
  audience?: Maybe<Scalars['String']>;
  campaign?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  creative?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};

export type SingleLinkQrTargetInput = {
  audience?: InputMaybe<Scalars['String']>;
  campaign?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  creative?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
};

export type SingleLinkTargetInput = {
  name: Scalars['String'];
  type: TargetType;
};

export type SingleLinkTargetModel = {
  __typename?: 'SingleLinkTargetModel';
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: TargetType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SingleLinkTargetsModel = {
  __typename?: 'SingleLinkTargetsModel';
  audience: Array<SingleLinkTargetModel>;
  campaign: Array<SingleLinkTargetModel>;
  channel: Array<SingleLinkTargetModel>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['Date']>;
  creative: Array<SingleLinkTargetModel>;
  id: Scalars['ID'];
  platform: Array<SingleLinkTargetModel>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['Date']>;
  vendor: Array<SingleLinkTargetModel>;
};

export enum SingleLinkType {
  Email = 'Email',
  Location = 'Location',
  Sms = 'Sms',
  Text = 'Text',
  Url = 'Url',
  VCard = 'VCard',
  Wifi = 'Wifi'
}

export type SmsSignup = {
  __typename?: 'SmsSignup';
  buttonText: Scalars['String'];
  colors?: Maybe<SubscriberSignupColorsModel>;
  googleSheetUrl?: Maybe<Scalars['String']>;
  position: Position;
  storage?: Maybe<EmailProviders>;
  successMessage: Scalars['String'];
  terms?: Maybe<Terms>;
};

export type SmsSignupInput = {
  buttonText?: Scalars['String'];
  colors?: InputMaybe<SubscriberSignupColorsInput>;
  googleSheetUrl?: InputMaybe<Scalars['String']>;
  position?: Position;
  storage?: InputMaybe<EmailProviders>;
  successMessage?: Scalars['String'];
  terms?: InputMaybe<TermsInput>;
};

export type SocialLink = {
  __typename?: 'SocialLink';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type Subscriber = {
  __typename?: 'Subscriber';
  value: Scalars['String'];
};

export type SubscriberModel = {
  __typename?: 'SubscriberModel';
  meta: Meta;
  subscriber: Array<Subscriber>;
};

export type SubscriberSignupColorsInput = {
  buttonColor?: Scalars['String'];
  buttonTextColor?: Scalars['String'];
};

export type SubscriberSignupColorsModel = {
  __typename?: 'SubscriberSignupColorsModel';
  buttonColor: Scalars['String'];
  buttonTextColor: Scalars['String'];
};

export enum SubscriptionPlan {
  Enterprise = 'Enterprise',
  Free = 'Free',
  Plus = 'Plus',
  Pro = 'Pro'
}

export enum TargetType {
  Audience = 'Audience',
  Campaign = 'Campaign',
  Channel = 'Channel',
  Creative = 'Creative',
  Platform = 'Platform',
  Vendor = 'Vendor'
}

export type Terms = {
  __typename?: 'Terms';
  linkLabel: Scalars['String'];
  termsLabel: Scalars['String'];
  termsLink: Scalars['String'];
};

export type TermsInput = {
  linkLabel?: Scalars['String'];
  termsLabel?: Scalars['String'];
  termsLink?: Scalars['String'];
};

export type Token = {
  __typename?: 'Token';
  /** JWT access token */
  accessToken: Scalars['String'];
  /** JWT refresh token */
  refreshToken: Scalars['String'];
};

export type TopThree = {
  __typename?: 'TopThree';
  topByClicks: Array<TopThreeByClicks>;
  topByLocations: Array<TopThreeByLocations>;
  topByViews: Array<TopThreePagesByViews>;
};

export type TopThreeByClicks = {
  __typename?: 'TopThreeByClicks';
  clicks: Scalars['Int'];
  pagename: Scalars['String'];
};

export type TopThreeByLocations = {
  __typename?: 'TopThreeByLocations';
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
  views: Scalars['Int'];
};

export type TopThreePagesByViews = {
  __typename?: 'TopThreePagesByViews';
  pagename: Scalars['String'];
  views: Scalars['Int'];
};

export type UnsplashAutor = {
  __typename?: 'UnsplashAutor';
  name: Scalars['String'];
  unsplashLink: Scalars['String'];
};

export type UnsplashPhoto = {
  __typename?: 'UnsplashPhoto';
  autor: UnsplashAutor;
  downloadLocation: Scalars['String'];
  rawUrl: Scalars['String'];
};

export type UpdateCustomerSubscription = {
  customerId: Scalars['String'];
  plan: SubscriptionPlan;
  price: Scalars['Float'];
};

export type UpdateLinkInput = {
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateLinkInputOrder = {
  childRow: Scalars['Int'];
  id: Scalars['String'];
  order: Scalars['Int'];
};

export type UpdateLinkModifier = {
  childRow?: InputMaybe<Scalars['Int']>;
  embeded?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  leapTime?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
  scheduleEnd?: InputMaybe<Scalars['String']>;
  scheduleStart?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LinkType>;
};

export type UpdatePromocodeInput = {
  expiration?: InputMaybe<Scalars['Date']>;
  id: Scalars['String'];
  maxCustomer?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type UpdateUserInput = {
  avatar?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UtmCodesInput = {
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
};

export type UtmCodesModel = {
  __typename?: 'UtmCodesModel';
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
};

export type WeekNumbers = {
  __typename?: 'WeekNumbers';
  day: Interval;
  week: Interval;
};

export type AdminSignInMutationVariables = Exact<{
  data: AdminLoginInput;
}>;


export type AdminSignInMutation = { __typename?: 'Mutation', adminLogin: { __typename?: 'AdminAuth', accessToken: string } };

export type MeAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type MeAdminQuery = { __typename?: 'Query', meAdmin: { __typename?: 'AdminModel', email: string } };

export type AllCustomersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AllCustomersQuery = { __typename?: 'Query', allCustomers: Array<{ __typename?: 'Customer', id: string, customerPagesCount: number, fullName?: string | null, email: string, username: string, createdAt?: any | null, subscriptionPlan: { __typename?: 'CustomerSubscription', status: string, stripePlanId: string, plan: SubscriptionPlan } }> };

export type SearchCustomerQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type SearchCustomerQuery = { __typename?: 'Query', searchCustomer: Array<{ __typename?: 'Customer', id: string, customerPagesCount: number, fullName?: string | null, email: string, username: string, createdAt?: any | null, subscriptionPlan: { __typename?: 'CustomerSubscription', status: string, stripePlanId: string, plan: SubscriptionPlan } }> };

export type DeletingCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type DeletingCustomersQuery = { __typename?: 'Query', deletingCustomers: Array<{ __typename?: 'Customer', id: string, email: string, username: string, deleteTime?: any | null }> };

export type AllPromocodesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AllPromocodesQuery = { __typename?: 'Query', allPromocodes: Array<{ __typename?: 'PromoCodeModel', id: string, value: string, numberUses: number, maxCustomer: number, expiration?: any | null }> };

export type CustomersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomersCountQuery = { __typename?: 'Query', getCountOfCustomers: number };

export type CodesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type CodesCountQuery = { __typename?: 'Query', getCountOfCodes: number };

export type CustomerDetailQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type CustomerDetailQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, username: string, customerPagesListAdmin: Array<string>, deleteTime?: any | null, blocked: boolean, deleted: boolean, subscriptionPlan: { __typename?: 'CustomerSubscription', status: string, price: number, id: string, end_date?: any | null, currency: string, price_id?: string | null, plan: SubscriptionPlan } } };

export type GetQrCodesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetQrCodesQuery = { __typename?: 'Query', getQrCodes: Array<{ __typename?: 'AdminQrLinkModel', id: string, owner: string, url: string, createdAt?: any | null }> };

export type GetBioLinksQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetBioLinksQuery = { __typename?: 'Query', getBioLinks: Array<{ __typename?: 'AdminQrLinkModel', id: string, owner: string, url: string, createdAt?: any | null }> };

export type SearchQrCodesQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type SearchQrCodesQuery = { __typename?: 'Query', searchQrCodes: Array<{ __typename?: 'AdminQrLinkModel', id: string, owner: string, url: string, createdAt?: any | null }> };

export type SearchBioLinksQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type SearchBioLinksQuery = { __typename?: 'Query', searchBioLinks: Array<{ __typename?: 'AdminQrLinkModel', id: string, owner: string, url: string, createdAt?: any | null }> };

export type GetBioLinksCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBioLinksCountQuery = { __typename?: 'Query', getBioLinksCount: number };

export type GetQrCodesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQrCodesCountQuery = { __typename?: 'Query', getQrCodesCount: number };

export type UpdateDefaultPlanSettingMutationVariables = Exact<{
  data: AuthSettingsDefaultPlanInput;
}>;


export type UpdateDefaultPlanSettingMutation = { __typename?: 'Mutation', updateDefaultPlanSetting: { __typename?: 'AuthDefaultPlanSettingsModel', duration: number, defaultPlanName: SubscriptionPlan } };

export type DeleteQrCodeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteQrCodeMutation = { __typename?: 'Mutation', deleteQrCode: boolean };

export type DeleteBioLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBioLinkMutation = { __typename?: 'Mutation', deleteBioLink: boolean };

export type GetSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSettingsQuery = { __typename?: 'Query', getSettings: { __typename?: 'SettingsModel', authSettings: { __typename?: 'AuthSettingsModel', defaultPlan: { __typename?: 'AuthDefaultPlanSettingsModel', duration: number, defaultPlanName: SubscriptionPlan } } } };

export type TopThreeStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type TopThreeStatsQuery = { __typename?: 'Query', topThreeStats: { __typename?: 'TopThree', topByViews: Array<{ __typename?: 'TopThreePagesByViews', title: string, count: number }>, topByClicks: Array<{ __typename?: 'TopThreeByClicks', title: string, count: number }>, topByLocations: Array<{ __typename?: 'TopThreeByLocations', country: string, state: string, title: string, count: number }> } };

export type WeekStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type WeekStatsQuery = { __typename?: 'Query', weekStats: { __typename?: 'WeekNumbers', day: { __typename?: 'Interval', clicks: number, views: number }, week: { __typename?: 'Interval', clicks: number, views: number } } };

export type SnapshotChartsQueryVariables = Exact<{
  period: JoyqrStatPeriodType;
}>;


export type SnapshotChartsQuery = { __typename?: 'Query', snapshotCharts: Array<Array<{ __typename?: 'ChartModel', day: string, count: number }>> };

export type AdminChartQueryVariables = Exact<{
  type: AdminAnalyticsChartType;
  period: JoyqrStatPeriodType;
}>;


export type AdminChartQuery = { __typename?: 'Query', chartData: Array<{ __typename?: 'ChartModel', day: string, count: number }> };

export type ChangeBlockStateMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ChangeBlockStateMutation = { __typename?: 'Mutation', changeBlockState: { __typename?: 'Customer', id: string, blocked: boolean } };

export type CreatePromocodeMutationVariables = Exact<{
  promocode: CreatePromocodeInput;
}>;


export type CreatePromocodeMutation = { __typename?: 'Mutation', createPromocode: { __typename?: 'PromoCodeModel', value: string, numberUses: number, maxCustomer: number, expiration?: any | null } };

export type CreateRandomPromocodeMutationVariables = Exact<{
  promocode: CreateRandomPromocodeInput;
}>;


export type CreateRandomPromocodeMutation = { __typename?: 'Mutation', createRandomPromocodes: number };

export type UpdatePromocodeMutationVariables = Exact<{
  promocode: UpdatePromocodeInput;
}>;


export type UpdatePromocodeMutation = { __typename?: 'Mutation', updatePromocode: { __typename?: 'PromoCodeModel', id: string, value: string, numberUses: number, maxCustomer: number, expiration?: any | null } };

export type UpdateSubscriptionAdminMutationVariables = Exact<{
  plan: UpdateCustomerSubscription;
}>;


export type UpdateSubscriptionAdminMutation = { __typename?: 'Mutation', updateSubscriptionAdmin: string };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type SignInMutationVariables = Exact<{
  data: LoginInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', login: { __typename?: 'Auth', accessToken: string } };

export type SignUpMutationVariables = Exact<{
  data: SignupInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signup: { __typename?: 'Auth', accessToken: string } };

export type LinkPropsFragment = { __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null };

export type LinkFragment = { __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null, children: Array<{ __typename?: 'Children', rowId: string, row: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null }> }> };

export type SettingsFragment = { __typename?: 'PageSettingsModel', favicon?: string | null, analytics: { __typename?: 'Analytics', fb?: string | null, google?: string | null, utmCodes?: { __typename?: 'UtmCodesModel', utmMedium?: string | null, utmSource?: string | null } | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null } | null, emailSignup?: { __typename?: 'EmailSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, mailchimpApi?: string | null, mailchimpList?: string | null, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, smsSignup?: { __typename?: 'SmsSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, infoBanner?: { __typename?: 'InfoBanner', title: string, font: string, content: string, buttonLabel: string, buttonUrl: string, colors?: { __typename?: 'InfoBannerColors', buttonBg: string, background: string, buttonLabel: string, content: string, title: string } | null } | null, sensitive?: { __typename?: 'SensitiveMaterial', type: AgeType } | null, seo?: { __typename?: 'Seo', title: string, description: string } | null };

export type QrFragment = { __typename?: 'QrModel', tags: Array<string>, padding: number, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null };

export type QrSingleLinkFragment = { __typename?: 'QrModel', padding: number, copyText: boolean, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null };

export type AppearanceFragment = { __typename?: 'AppearanceModel', profileImage?: string | null, colors: Array<string>, logo: boolean, title: { __typename?: 'PageTitleModel', value: string, fontSize: number, font: string, color: string }, social?: { __typename?: 'PageSocialIconsModel', iconsColor: string } | null, bio: { __typename?: 'PageBioModel', value: string, font: string, fontSize: number, color: string }, theme: { __typename?: 'PageThemeModel', id: string, custom?: { __typename?: 'PageCustomThemeModel', bgImage?: string | null, bgFilter?: string | null, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } } | null }, buttons?: { __typename?: 'PageButtonModel', id: string, custom?: { __typename?: 'PageCustomButtonModel', color: { __typename?: 'PageCustomButtonColorModel', bgColor: string, shadowColor: string, textColor: string, hoverColor: string }, stroke?: { __typename?: 'PageCustomButtonStrokeModel', color: string, width: number } | null } | null } | null, font: { __typename?: 'PageFontModel', id: number, size: number, family: string } };

export type PageFragment = { __typename?: 'PageModel', id: string, pagename: string, domainId?: string | null, domain?: { __typename?: 'DomainModel', id: string, domain: string } | null, appearance: { __typename?: 'AppearanceModel', profileImage?: string | null, colors: Array<string>, logo: boolean, title: { __typename?: 'PageTitleModel', value: string, fontSize: number, font: string, color: string }, social?: { __typename?: 'PageSocialIconsModel', iconsColor: string } | null, bio: { __typename?: 'PageBioModel', value: string, font: string, fontSize: number, color: string }, theme: { __typename?: 'PageThemeModel', id: string, custom?: { __typename?: 'PageCustomThemeModel', bgImage?: string | null, bgFilter?: string | null, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } } | null }, buttons?: { __typename?: 'PageButtonModel', id: string, custom?: { __typename?: 'PageCustomButtonModel', color: { __typename?: 'PageCustomButtonColorModel', bgColor: string, shadowColor: string, textColor: string, hoverColor: string }, stroke?: { __typename?: 'PageCustomButtonStrokeModel', color: string, width: number } | null } | null } | null, font: { __typename?: 'PageFontModel', id: number, size: number, family: string } }, settings: { __typename?: 'PageSettingsModel', favicon?: string | null, analytics: { __typename?: 'Analytics', fb?: string | null, google?: string | null, utmCodes?: { __typename?: 'UtmCodesModel', utmMedium?: string | null, utmSource?: string | null } | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null } | null, emailSignup?: { __typename?: 'EmailSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, mailchimpApi?: string | null, mailchimpList?: string | null, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, smsSignup?: { __typename?: 'SmsSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, infoBanner?: { __typename?: 'InfoBanner', title: string, font: string, content: string, buttonLabel: string, buttonUrl: string, colors?: { __typename?: 'InfoBannerColors', buttonBg: string, background: string, buttonLabel: string, content: string, title: string } | null } | null, sensitive?: { __typename?: 'SensitiveMaterial', type: AgeType } | null, seo?: { __typename?: 'Seo', title: string, description: string } | null }, qr: { __typename?: 'QrModel', tags: Array<string>, padding: number, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null }, links: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null, children: Array<{ __typename?: 'Children', rowId: string, row: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null }> }> }> };

export type SubscriptionPlanInfoFragment = { __typename?: 'CustomerSubscription', id: string, price_id?: string | null, end_date?: any | null, name: SubscriptionPlan, price: number, currency: string, status: string, canTrial: boolean };

export type PersonalInfoFragment = { __typename?: 'Customer', fullName?: string | null, email: string, timezone?: string | null };

export type IntegrationsFragment = { __typename?: 'Customer', integrations: Array<{ __typename?: 'Integration', provider: IntegrationProvider, username?: string | null }> };

export type ReportsFragment = { __typename?: 'CustomDashboard', reports: Array<{ __typename?: 'CustomDashboardReport', id: string }> };

export type CreateCustomDashboardMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateCustomDashboardMutation = { __typename?: 'Mutation', createCustomDashboard: { __typename?: 'CustomDashboard', id: string, title: string } };

export type CreateCustomReportMutationVariables = Exact<{
  data: CustomReportInput;
}>;


export type CreateCustomReportMutation = { __typename?: 'Mutation', createCustomReport: { __typename?: 'CustomDashboardReport', id: string, config: any } };

export type UpdateDashboardGridMutationVariables = Exact<{
  dashboardId: Scalars['String'];
  data: Array<CustomReportUpdatePositionInput> | CustomReportUpdatePositionInput;
}>;


export type UpdateDashboardGridMutation = { __typename?: 'Mutation', updateDashboardGrid: string };

export type FiltersQueryVariables = Exact<{
  filter: Scalars['String'];
}>;


export type FiltersQuery = { __typename?: 'Query', filters: Array<string> };

export type CustomDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomDashboardsQuery = { __typename?: 'Query', customDashboards: Array<{ __typename?: 'CustomDashboard', id: string, title: string, reports: Array<{ __typename?: 'CustomDashboardReport', id: string }> }> };

export type DeleteReportMutationVariables = Exact<{
  reportId: Scalars['String'];
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport: string };

export type UpdateDashboardNameMutationVariables = Exact<{
  dashboardId: Scalars['String'];
  dashboardName: Scalars['String'];
}>;


export type UpdateDashboardNameMutation = { __typename?: 'Mutation', updateDashboardName: string };

export type DeleteDashboardMutationVariables = Exact<{
  dashboardId: Scalars['String'];
}>;


export type DeleteDashboardMutation = { __typename?: 'Mutation', deleteDashboard: string };

export type ReportQueryVariables = Exact<{
  reportId: Scalars['String'];
}>;


export type ReportQuery = { __typename?: 'Query', report: { __typename?: 'CustomDashboardReport', id: string, title: string, config: any, series: Array<{ __typename?: 'MetricSeries', metricId: number, serie: Array<{ __typename?: 'ChartData', date?: any | null, count: number, city?: string | null, state?: string | null, country?: string | null, day?: string | null, part?: string | null, os?: string | null, device?: string | null, title?: string | null }> }> } };

export type CustomDashboardEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomDashboardEventsQuery = { __typename?: 'Query', customDashboardEvents: { __typename?: 'CustomDashboardEvents', pageViews: Array<{ __typename?: 'CustomDashboardEvent', id: string, title: string }>, linkClicks: Array<{ __typename?: 'CustomDashboardEvent', id: string, title: string }>, socialLinkClicks: Array<{ __typename?: 'CustomDashboardEvent', id: string, title: string }>, qrScans: Array<{ __typename?: 'CustomDashboardEvent', id: string, title: string }>, targetScans: Array<{ __typename?: 'CustomDashboardEvent', id: string, title: string }> } };

export type EventDataQueryVariables = Exact<{
  event: Scalars['String'];
  itemId: Scalars['String'];
  type: Scalars['String'];
  date: DateInterval;
  filters?: InputMaybe<Array<QueryFilter> | QueryFilter>;
  groups?: InputMaybe<Array<GroupByFilter> | GroupByFilter>;
}>;


export type EventDataQuery = { __typename?: 'Query', eventData: Array<{ __typename?: 'ChartData', date?: any | null, count: number, city?: string | null, state?: string | null, country?: string | null, day?: string | null, part?: string | null, os?: string | null, device?: string | null, title?: string | null }> };

export type CustomDashboardQueryVariables = Exact<{
  dashboardId: Scalars['String'];
}>;


export type CustomDashboardQuery = { __typename?: 'Query', dashboard: { __typename?: 'CustomDashboard', id: string, title: string, reports: Array<{ __typename?: 'CustomDashboardReport', id: string, title: string, config: any, series: Array<{ __typename?: 'MetricSeries', metricId: number, serie: Array<{ __typename?: 'ChartData', date?: any | null, count: number, city?: string | null, state?: string | null, country?: string | null, day?: string | null, part?: string | null, os?: string | null, title?: string | null, device?: string | null }> }> }> } };

export type CreateEmailSubscriberMutationVariables = Exact<{
  data: CreateEmailSubscriber;
}>;


export type CreateEmailSubscriberMutation = { __typename?: 'Mutation', createEmailSubscriber: string };

export type CreateSmsSubscriberMutationVariables = Exact<{
  data: CreateSmsSubscriber;
}>;


export type CreateSmsSubscriberMutation = { __typename?: 'Mutation', createSmsSubscriber: string };

export type AnalyticEventMutationVariables = Exact<{
  data: AnalyticEventInput;
}>;


export type AnalyticEventMutation = { __typename?: 'Mutation', analyticEvent: string };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'Customer', id: string, createdAt?: any | null, username: string, customerPagesList: any, selectedFeature: SelectedFeature, deleted: boolean, avatar?: string | null, active: boolean, fullName?: string | null, email: string, timezone?: string | null, subscriptionPlan: { __typename?: 'CustomerSubscription', id: string, price_id?: string | null, end_date?: any | null, name: SubscriptionPlan, price: number, currency: string, status: string, canTrial: boolean }, page: { __typename?: 'PageModel', id: string, pagename: string, domainId?: string | null, domain?: { __typename?: 'DomainModel', id: string, domain: string } | null, appearance: { __typename?: 'AppearanceModel', profileImage?: string | null, colors: Array<string>, logo: boolean, title: { __typename?: 'PageTitleModel', value: string, fontSize: number, font: string, color: string }, social?: { __typename?: 'PageSocialIconsModel', iconsColor: string } | null, bio: { __typename?: 'PageBioModel', value: string, font: string, fontSize: number, color: string }, theme: { __typename?: 'PageThemeModel', id: string, custom?: { __typename?: 'PageCustomThemeModel', bgImage?: string | null, bgFilter?: string | null, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } } | null }, buttons?: { __typename?: 'PageButtonModel', id: string, custom?: { __typename?: 'PageCustomButtonModel', color: { __typename?: 'PageCustomButtonColorModel', bgColor: string, shadowColor: string, textColor: string, hoverColor: string }, stroke?: { __typename?: 'PageCustomButtonStrokeModel', color: string, width: number } | null } | null } | null, font: { __typename?: 'PageFontModel', id: number, size: number, family: string } }, settings: { __typename?: 'PageSettingsModel', favicon?: string | null, analytics: { __typename?: 'Analytics', fb?: string | null, google?: string | null, utmCodes?: { __typename?: 'UtmCodesModel', utmMedium?: string | null, utmSource?: string | null } | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null } | null, emailSignup?: { __typename?: 'EmailSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, mailchimpApi?: string | null, mailchimpList?: string | null, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, smsSignup?: { __typename?: 'SmsSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, infoBanner?: { __typename?: 'InfoBanner', title: string, font: string, content: string, buttonLabel: string, buttonUrl: string, colors?: { __typename?: 'InfoBannerColors', buttonBg: string, background: string, buttonLabel: string, content: string, title: string } | null } | null, sensitive?: { __typename?: 'SensitiveMaterial', type: AgeType } | null, seo?: { __typename?: 'Seo', title: string, description: string } | null }, qr: { __typename?: 'QrModel', tags: Array<string>, padding: number, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null }, links: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null, children: Array<{ __typename?: 'Children', rowId: string, row: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null }> }> }> }, integrations: Array<{ __typename?: 'Integration', provider: IntegrationProvider, username?: string | null }> } };

export type CheckUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type CheckUsernameQuery = { __typename?: 'Query', checkUsername: boolean };

export type MePersonalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MePersonalInfoQuery = { __typename?: 'Query', me: { __typename?: 'Customer', fullName?: string | null, email: string, timezone?: string | null } };

export type EmbeddedQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type EmbeddedQuery = { __typename?: 'Query', embeded?: string | null };

export type UnsplashPhotoQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type UnsplashPhotoQuery = { __typename?: 'Query', getUnsplashPhotos?: Array<{ __typename?: 'UnsplashPhoto', downloadLocation: string, rawUrl: string, autor: { __typename?: 'UnsplashAutor', name: string, unsplashLink: string } }> | null };

export type SelectFeatureMutationVariables = Exact<{
  feature: SelectedFeature;
}>;


export type SelectFeatureMutation = { __typename?: 'Mutation', selectFeature: SelectedFeature };

export type CreatePageMutationVariables = Exact<{
  pagename: Scalars['String'];
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPage: { __typename?: 'PageModel', id: string, pagename: string, domainId?: string | null, domain?: { __typename?: 'DomainModel', id: string, domain: string } | null, appearance: { __typename?: 'AppearanceModel', profileImage?: string | null, colors: Array<string>, logo: boolean, title: { __typename?: 'PageTitleModel', value: string, fontSize: number, font: string, color: string }, social?: { __typename?: 'PageSocialIconsModel', iconsColor: string } | null, bio: { __typename?: 'PageBioModel', value: string, font: string, fontSize: number, color: string }, theme: { __typename?: 'PageThemeModel', id: string, custom?: { __typename?: 'PageCustomThemeModel', bgImage?: string | null, bgFilter?: string | null, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } } | null }, buttons?: { __typename?: 'PageButtonModel', id: string, custom?: { __typename?: 'PageCustomButtonModel', color: { __typename?: 'PageCustomButtonColorModel', bgColor: string, shadowColor: string, textColor: string, hoverColor: string }, stroke?: { __typename?: 'PageCustomButtonStrokeModel', color: string, width: number } | null } | null } | null, font: { __typename?: 'PageFontModel', id: number, size: number, family: string } }, settings: { __typename?: 'PageSettingsModel', favicon?: string | null, analytics: { __typename?: 'Analytics', fb?: string | null, google?: string | null, utmCodes?: { __typename?: 'UtmCodesModel', utmMedium?: string | null, utmSource?: string | null } | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null } | null, emailSignup?: { __typename?: 'EmailSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, mailchimpApi?: string | null, mailchimpList?: string | null, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, smsSignup?: { __typename?: 'SmsSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, infoBanner?: { __typename?: 'InfoBanner', title: string, font: string, content: string, buttonLabel: string, buttonUrl: string, colors?: { __typename?: 'InfoBannerColors', buttonBg: string, background: string, buttonLabel: string, content: string, title: string } | null } | null, sensitive?: { __typename?: 'SensitiveMaterial', type: AgeType } | null, seo?: { __typename?: 'Seo', title: string, description: string } | null }, qr: { __typename?: 'QrModel', tags: Array<string>, padding: number, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null }, links: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null, children: Array<{ __typename?: 'Children', rowId: string, row: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null }> }> }> } };

export type SelectPageMutationVariables = Exact<{
  pageId: Scalars['String'];
}>;


export type SelectPageMutation = { __typename?: 'Mutation', selectPage: { __typename?: 'PageModel', id: string, pagename: string, domainId?: string | null, domain?: { __typename?: 'DomainModel', id: string, domain: string } | null, appearance: { __typename?: 'AppearanceModel', profileImage?: string | null, colors: Array<string>, logo: boolean, title: { __typename?: 'PageTitleModel', value: string, fontSize: number, font: string, color: string }, social?: { __typename?: 'PageSocialIconsModel', iconsColor: string } | null, bio: { __typename?: 'PageBioModel', value: string, font: string, fontSize: number, color: string }, theme: { __typename?: 'PageThemeModel', id: string, custom?: { __typename?: 'PageCustomThemeModel', bgImage?: string | null, bgFilter?: string | null, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } } | null }, buttons?: { __typename?: 'PageButtonModel', id: string, custom?: { __typename?: 'PageCustomButtonModel', color: { __typename?: 'PageCustomButtonColorModel', bgColor: string, shadowColor: string, textColor: string, hoverColor: string }, stroke?: { __typename?: 'PageCustomButtonStrokeModel', color: string, width: number } | null } | null } | null, font: { __typename?: 'PageFontModel', id: number, size: number, family: string } }, settings: { __typename?: 'PageSettingsModel', favicon?: string | null, analytics: { __typename?: 'Analytics', fb?: string | null, google?: string | null, utmCodes?: { __typename?: 'UtmCodesModel', utmMedium?: string | null, utmSource?: string | null } | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null } | null, emailSignup?: { __typename?: 'EmailSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, mailchimpApi?: string | null, mailchimpList?: string | null, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, smsSignup?: { __typename?: 'SmsSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, infoBanner?: { __typename?: 'InfoBanner', title: string, font: string, content: string, buttonLabel: string, buttonUrl: string, colors?: { __typename?: 'InfoBannerColors', buttonBg: string, background: string, buttonLabel: string, content: string, title: string } | null } | null, sensitive?: { __typename?: 'SensitiveMaterial', type: AgeType } | null, seo?: { __typename?: 'Seo', title: string, description: string } | null }, qr: { __typename?: 'QrModel', tags: Array<string>, padding: number, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null }, links: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null, children: Array<{ __typename?: 'Children', rowId: string, row: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null }> }> }> } };

export type DeletePageMutationVariables = Exact<{
  pageId: Scalars['String'];
}>;


export type DeletePageMutation = { __typename?: 'Mutation', deletePage: string };

export type UpdateMeMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'Customer', id: string, username: string, fullName?: string | null, email: string, timezone?: string | null } };

export type ChangePasswordMutationVariables = Exact<{
  data: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'Customer', id: string } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: string };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: string };

export type DeleteMeMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteMeMutation = { __typename?: 'Mutation', deleteMe: boolean };

export type CancelDeleteMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelDeleteMutation = { __typename?: 'Mutation', cancelDelete: boolean };

export type CreateQrTagMutationVariables = Exact<{
  tag: Scalars['String'];
}>;


export type CreateQrTagMutation = { __typename?: 'Mutation', createQrTag: string };

export type DeleteQrTagMutationVariables = Exact<{
  tag: Scalars['String'];
}>;


export type DeleteQrTagMutation = { __typename?: 'Mutation', deleteQrTag: Array<string> };

export type ResendActivationMailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendActivationMailMutation = { __typename?: 'Mutation', resendActivationMail: string };

export type InstagramPostsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type InstagramPostsQuery = { __typename?: 'Query', instagramPosts: { __typename?: 'InstagramResponseModel', next?: string | null, data: Array<{ __typename?: 'InstagramPostModel', id: string, media_url: string }> } };

export type DeleteQrTemplateMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteQrTemplateMutation = { __typename?: 'Mutation', deleteQrTemplate: boolean };

export type CustomDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomDomainsQuery = { __typename?: 'Query', customDomains: Array<{ __typename?: 'DomainModel', id: string, domain: string, errorPage?: string | null, usedInPage?: string | null }> };

export type CreateDomainMutationVariables = Exact<{
  data: CreateDomainInput;
}>;


export type CreateDomainMutation = { __typename?: 'Mutation', createDomain: { __typename?: 'DomainModel', id: string, domain: string, errorPage?: string | null, usedInPage?: string | null } };

export type DeleteDomainMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDomainMutation = { __typename?: 'Mutation', deleteDomain: string };

export type InsightQueryVariables = Exact<{
  type: InsightType;
  query: InsightDataQuery;
  id?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<DateInterval>;
}>;


export type InsightQuery = { __typename?: 'Query', insight: { __typename?: 'InsightReport', id: string, config: any, series: Array<{ __typename?: 'MetricSeries', metricId: number, serie: Array<{ __typename?: 'ChartData', date?: any | null, count: number, city?: string | null, state?: string | null, country?: string | null, day?: string | null, part?: string | null, os?: string | null, title?: string | null, device?: string | null, lat?: string | null, lon?: string | null }> }> } };

export type GetQrNamesQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  category?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetQrNamesQuery = { __typename?: 'Query', getSingleLinks: { __typename?: 'PaginatedLinks', nodes: Array<{ __typename?: 'SingleLinkModel', id: string, title?: string | null, categoryName?: string | null, singleLinkCategoryId?: string | null }> } };

export type MePageQueryVariables = Exact<{ [key: string]: never; }>;


export type MePageQuery = { __typename?: 'Query', me: { __typename?: 'Customer', page: { __typename?: 'PageModel', id: string, pagename: string, domainId?: string | null, domain?: { __typename?: 'DomainModel', id: string, domain: string } | null, appearance: { __typename?: 'AppearanceModel', profileImage?: string | null, colors: Array<string>, logo: boolean, title: { __typename?: 'PageTitleModel', value: string, fontSize: number, font: string, color: string }, social?: { __typename?: 'PageSocialIconsModel', iconsColor: string } | null, bio: { __typename?: 'PageBioModel', value: string, font: string, fontSize: number, color: string }, theme: { __typename?: 'PageThemeModel', id: string, custom?: { __typename?: 'PageCustomThemeModel', bgImage?: string | null, bgFilter?: string | null, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } } | null }, buttons?: { __typename?: 'PageButtonModel', id: string, custom?: { __typename?: 'PageCustomButtonModel', color: { __typename?: 'PageCustomButtonColorModel', bgColor: string, shadowColor: string, textColor: string, hoverColor: string }, stroke?: { __typename?: 'PageCustomButtonStrokeModel', color: string, width: number } | null } | null } | null, font: { __typename?: 'PageFontModel', id: number, size: number, family: string } }, settings: { __typename?: 'PageSettingsModel', favicon?: string | null, analytics: { __typename?: 'Analytics', fb?: string | null, google?: string | null, utmCodes?: { __typename?: 'UtmCodesModel', utmMedium?: string | null, utmSource?: string | null } | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null } | null, emailSignup?: { __typename?: 'EmailSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, mailchimpApi?: string | null, mailchimpList?: string | null, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, smsSignup?: { __typename?: 'SmsSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, infoBanner?: { __typename?: 'InfoBanner', title: string, font: string, content: string, buttonLabel: string, buttonUrl: string, colors?: { __typename?: 'InfoBannerColors', buttonBg: string, background: string, buttonLabel: string, content: string, title: string } | null } | null, sensitive?: { __typename?: 'SensitiveMaterial', type: AgeType } | null, seo?: { __typename?: 'Seo', title: string, description: string } | null }, qr: { __typename?: 'QrModel', tags: Array<string>, padding: number, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null }, links: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null, children: Array<{ __typename?: 'Children', rowId: string, row: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null }> }> }> } } };

export type SubscribersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
}>;


export type SubscribersQuery = { __typename?: 'Query', subscribers: { __typename?: 'SubscriberModel', subscriber: Array<{ __typename?: 'Subscriber', value: string }>, meta: { __typename?: 'Meta', count: number } } };

export type MailchimpListsQueryVariables = Exact<{
  apiKey: Scalars['String'];
}>;


export type MailchimpListsQuery = { __typename?: 'Query', mailchimpLists: any };

export type CreateLinkMutationVariables = Exact<{
  parent?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LinkType>;
}>;


export type CreateLinkMutation = { __typename?: 'Mutation', createPageLink: { __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null, children: Array<{ __typename?: 'Children', rowId: string, row: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null }> }> } };

export type CreateGridLinksMutationVariables = Exact<{
  parent?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
}>;


export type CreateGridLinksMutation = { __typename?: 'Mutation', createGridLinks: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null }> };

export type UpdateLinkModifierMutationVariables = Exact<{
  data: UpdateLinkModifier;
}>;


export type UpdateLinkModifierMutation = { __typename?: 'Mutation', updateLinkModifier: { __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null, children: Array<{ __typename?: 'Children', rowId: string, row: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null }> }> } };

export type UpdateLinksOrderMutationVariables = Exact<{
  data: Array<UpdateLinkInputOrder> | UpdateLinkInputOrder;
}>;


export type UpdateLinksOrderMutation = { __typename?: 'Mutation', updateLinksOrder: Array<{ __typename?: 'LinkModel', id: string, order: number }> };

export type UpdateLinkMutationVariables = Exact<{
  data: UpdateLinkInput;
}>;


export type UpdateLinkMutation = { __typename?: 'Mutation', updateLink: { __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null, children: Array<{ __typename?: 'Children', rowId: string, row: Array<{ __typename?: 'LinkModel', id: string, title: string, url: string, embeded: boolean, embededIframe?: string | null, isActive: boolean, priority: number, order: number, leapTime: number, scheduleStart?: string | null, scheduleEnd?: string | null, scheduleTimezone?: string | null, thumbnail?: string | null, type: LinkType, childRow: number, clicks?: number | null, isLinkValid?: boolean | null, isNew?: boolean | null, urlHolder?: string | null }> }> } };

export type ApplyPromoMutationVariables = Exact<{
  data: Scalars['String'];
}>;


export type ApplyPromoMutation = { __typename?: 'Mutation', applyPromoCode: string };

export type DeleteLinkMutationVariables = Exact<{
  data: DeleteLinkInput;
}>;


export type DeleteLinkMutation = { __typename?: 'Mutation', deleteLink: { __typename?: 'LinkModel', id: string } };

export type UpdateAppearanceMutationVariables = Exact<{
  data: AppearanceInput;
}>;


export type UpdateAppearanceMutation = { __typename?: 'Mutation', updateAppearance: { __typename?: 'AppearanceModel', profileImage?: string | null, colors: Array<string>, logo: boolean, title: { __typename?: 'PageTitleModel', value: string, fontSize: number, font: string, color: string }, social?: { __typename?: 'PageSocialIconsModel', iconsColor: string } | null, bio: { __typename?: 'PageBioModel', value: string, font: string, fontSize: number, color: string }, theme: { __typename?: 'PageThemeModel', id: string, custom?: { __typename?: 'PageCustomThemeModel', bgImage?: string | null, bgFilter?: string | null, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } } | null }, buttons?: { __typename?: 'PageButtonModel', id: string, custom?: { __typename?: 'PageCustomButtonModel', color: { __typename?: 'PageCustomButtonColorModel', bgColor: string, shadowColor: string, textColor: string, hoverColor: string }, stroke?: { __typename?: 'PageCustomButtonStrokeModel', color: string, width: number } | null } | null } | null, font: { __typename?: 'PageFontModel', id: number, size: number, family: string } } };

export type UpdateSettingsMutationVariables = Exact<{
  data: PageSettingsInput;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', updateSettings: { __typename?: 'PageSettingsModel', favicon?: string | null, analytics: { __typename?: 'Analytics', fb?: string | null, google?: string | null, utmCodes?: { __typename?: 'UtmCodesModel', utmMedium?: string | null, utmSource?: string | null } | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null } | null, emailSignup?: { __typename?: 'EmailSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, mailchimpApi?: string | null, mailchimpList?: string | null, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, smsSignup?: { __typename?: 'SmsSignup', buttonText: string, position: Position, storage?: EmailProviders | null, successMessage: string, googleSheetUrl?: string | null, terms?: { __typename?: 'Terms', linkLabel: string, termsLabel: string, termsLink: string } | null, colors?: { __typename?: 'SubscriberSignupColorsModel', buttonColor: string, buttonTextColor: string } | null } | null, infoBanner?: { __typename?: 'InfoBanner', title: string, font: string, content: string, buttonLabel: string, buttonUrl: string, colors?: { __typename?: 'InfoBannerColors', buttonBg: string, background: string, buttonLabel: string, content: string, title: string } | null } | null, sensitive?: { __typename?: 'SensitiveMaterial', type: AgeType } | null, seo?: { __typename?: 'Seo', title: string, description: string } | null } };

export type CreateQrMutationVariables = Exact<{
  data: QrInput;
}>;


export type CreateQrMutation = { __typename?: 'Mutation', createQr: { __typename?: 'QrModel', tags: Array<string>, padding: number, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null } };

export type UpdatePageDomainMutationVariables = Exact<{
  domainId?: InputMaybe<Scalars['String']>;
  pageId: Scalars['String'];
}>;


export type UpdatePageDomainMutation = { __typename?: 'Mutation', updatePageDomain?: { __typename?: 'DomainModel', id: string } | null };

export type DeleteEmailSubscriberMutationVariables = Exact<{
  data: DeleteEmailSubscriber;
}>;


export type DeleteEmailSubscriberMutation = { __typename?: 'Mutation', deleteEmailSubscriber: string };

export type GetSingleLinksQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  category?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
}>;


export type GetSingleLinksQuery = { __typename?: 'Query', getSingleLinks: { __typename?: 'PaginatedLinks', totalCount: number, nodes: Array<{ __typename?: 'SingleLinkModel', id: string, createdAt?: any | null, hash: string, url?: string | null, title?: string | null, scans?: number | null, categoryName?: string | null, domainId?: string | null, singleLinkCategoryId?: string | null, type: SingleLinkType, isPassive: boolean, qr?: { __typename?: 'QrModel', padding: number, copyText: boolean, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null } | null }> } };

export type GetSingleLinkQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSingleLinkQuery = { __typename?: 'Query', getSingleLink: { __typename?: 'SingleLinkModel', id: string, createdAt?: any | null, hash: string, url?: string | null, title?: string | null, categoryName?: string | null, singleLinkCategoryId?: string | null, password?: string | null, domainId?: string | null, type: SingleLinkType, isPassive: boolean, target?: { __typename?: 'SingleLinkQrTarget', platform?: string | null, channel?: string | null, audience?: string | null, campaign?: string | null, creative?: string | null, vendor?: string | null } | null, qr?: { __typename?: 'QrModel', padding: number, copyText: boolean, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null } | null } };

export type GetSingleLinksForFilterQueryVariables = Exact<{
  category?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetSingleLinksForFilterQuery = { __typename?: 'Query', filterLinks: { __typename?: 'PaginatedLinks', nodes: Array<{ __typename?: 'SingleLinkModel', id: string, title?: string | null, singleLinkCategoryId?: string | null }> } };

export type CreateTmpSingleLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateTmpSingleLinkQuery = { __typename?: 'Query', createTmpSingleLink: { __typename?: 'SingleLinkModel', id: string, title?: string | null, url?: string | null, hash: string, isPassive: boolean, singleLinkCategoryId?: string | null, target?: { __typename?: 'SingleLinkQrTarget', platform?: string | null, channel?: string | null, audience?: string | null, campaign?: string | null, creative?: string | null, vendor?: string | null } | null } };

export type SingleLinkCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type SingleLinkCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'SingleLinkCategoryModel', id: string, name: string, linksCount: number }> };

export type SingleLinkCategoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SingleLinkCategoryQuery = { __typename?: 'Query', category: { __typename?: 'SingleLinkCategoryModel', id: string, name: string, linksCount: number, scans: number } };

export type SingleLinkCategoryLinksQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SingleLinkCategoryLinksQuery = { __typename?: 'Query', category: { __typename?: 'SingleLinkCategoryModel', id: string, links: Array<{ __typename?: 'SingleLinkModel', id: string, title?: string | null }> } };

export type QrTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type QrTemplatesQuery = { __typename?: 'Query', qrTemplates: Array<{ __typename?: 'QrTemplateModel', id: string, appearance: any }> };

export type CreateQrTemplateMutationVariables = Exact<{
  data: QrTemplateInput;
}>;


export type CreateQrTemplateMutation = { __typename?: 'Mutation', createQrTemplate: { __typename?: 'QrTemplateModel', id: string, appearance: any } };

export type CreateSingleLinkCategoryMutationVariables = Exact<{
  data: SingleLinkCategoryInput;
}>;


export type CreateSingleLinkCategoryMutation = { __typename?: 'Mutation', createSingleLinkCategory: { __typename?: 'SingleLinkCategoryModel', id: string, name: string } };

export type UpdateSingleLinkCategoryMutationVariables = Exact<{
  data: SingleLinkCategoryUpdate;
}>;


export type UpdateSingleLinkCategoryMutation = { __typename?: 'Mutation', updateSingleLinkCategory: { __typename?: 'SingleLinkCategoryModel', id: string, name: string } };

export type UpdateSingleLinkMutationVariables = Exact<{
  data: SingleLinkInput;
}>;


export type UpdateSingleLinkMutation = { __typename?: 'Mutation', updateSingleLink: { __typename?: 'SingleLinkModel', id: string, title?: string | null, url?: string | null, hash: string, singleLinkCategoryId?: string | null, categoryName?: string | null, target?: { __typename?: 'SingleLinkQrTarget', platform?: string | null, channel?: string | null, audience?: string | null, campaign?: string | null, creative?: string | null, vendor?: string | null } | null, qr?: { __typename?: 'QrModel', padding: number, copyText: boolean, oldLogo?: string | null, frame: { __typename?: 'QrFrameModel', id: number, custom?: { __typename?: 'QrCusomFrameModel', type: string, label: string, labelColor: string, frameColor1: string, frameColor2: string, frameColorType: ColorType, frameColorAngle: number, labelSize: number } | null }, module: { __typename?: 'ModuleModel', id: number, color: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, eyes: { __typename?: 'EyeModel', lB: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, lT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string }, rT: { __typename?: 'EyeColorModel', external: string, externalId: number, internalId: number, internal: string } }, shape: { __typename?: 'QrShapeModel', type: string, bgSize: number, stroke: number, bgColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number }, strokeColor: { __typename?: 'GradientColorModel', firstColor: string, secondColor: string, type: ColorType, angle: number } }, logo?: { __typename?: 'QrLogoModel', hideBg: boolean, margin: number, size: number, thumbnail: string } | null } | null } };

export type RemoveSingleLinkFromCategoryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveSingleLinkFromCategoryMutation = { __typename?: 'Mutation', removeSingleLinkFromCategory: { __typename?: 'SingleLinkModel', id: string, singleLinkCategoryId?: string | null } };

export type DeleteSingleLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSingleLinkMutation = { __typename?: 'Mutation', deleteSingleLink: string };

export type DeleteCategoryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory: string };

export type TargetsPropsFragment = { __typename?: 'SingleLinkTargetModel', id: string, name: string };

export type GetTargetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTargetsQuery = { __typename?: 'Query', targets: { __typename?: 'SingleLinkTargetsModel', platform: Array<{ __typename?: 'SingleLinkTargetModel', id: string, name: string }>, channel: Array<{ __typename?: 'SingleLinkTargetModel', id: string, name: string }>, audience: Array<{ __typename?: 'SingleLinkTargetModel', id: string, name: string }>, campaign: Array<{ __typename?: 'SingleLinkTargetModel', id: string, name: string }>, creative: Array<{ __typename?: 'SingleLinkTargetModel', id: string, name: string }>, vendor: Array<{ __typename?: 'SingleLinkTargetModel', id: string, name: string }> } };

export type CreateSingleLinkTargetMutationVariables = Exact<{
  data: SingleLinkTargetInput;
}>;


export type CreateSingleLinkTargetMutation = { __typename?: 'Mutation', createSingleLinkTarget: { __typename?: 'SingleLinkTargetModel', id: string, name: string, type: TargetType } };

export const QrSingleLinkFragmentDoc = gql`
    fragment QrSingleLink on QrModel {
  padding
  frame {
    id
    custom {
      type
      label
      labelColor
      frameColor1
      frameColor2
      frameColorType
      frameColorAngle
      labelSize
    }
  }
  module {
    id
    color {
      firstColor
      secondColor
      type
      angle
    }
  }
  eyes {
    lB {
      external
      externalId
      internalId
      internal
    }
    lT {
      external
      externalId
      internalId
      internal
    }
    rT {
      external
      externalId
      internalId
      internal
    }
  }
  shape {
    type
    bgColor {
      firstColor
      secondColor
      type
      angle
    }
    bgSize
    strokeColor {
      firstColor
      secondColor
      type
      angle
    }
    stroke
  }
  logo: _logo {
    hideBg
    margin
    size
    thumbnail
  }
  oldLogo: logo
  copyText
}
    `;
export const AppearanceFragmentDoc = gql`
    fragment Appearance on AppearanceModel {
  profileImage
  title {
    value
    fontSize
    font
    color
  }
  social {
    iconsColor
  }
  bio {
    value
    font
    fontSize
    color
  }
  theme {
    id
    custom {
      bgImage
      bgFilter
      color {
        firstColor
        secondColor
        type
        angle
      }
    }
  }
  buttons {
    id
    custom {
      color {
        bgColor
        shadowColor
        textColor
        hoverColor
      }
      stroke {
        color
        width
      }
    }
  }
  font {
    id
    size
    family
  }
  colors
  logo
}
    `;
export const SettingsFragmentDoc = gql`
    fragment Settings on PageSettingsModel {
  analytics {
    fb
    google
    utmCodes {
      utmMedium
      utmSource
    }
  }
  contact {
    email
    phone
  }
  emailSignup {
    buttonText
    position
    storage
    successMessage
    mailchimpApi
    mailchimpList
    googleSheetUrl
    terms {
      linkLabel
      termsLabel
      termsLink
    }
    colors {
      buttonColor
      buttonTextColor
    }
  }
  smsSignup {
    buttonText
    position
    storage
    successMessage
    googleSheetUrl
    terms {
      linkLabel
      termsLabel
      termsLink
    }
    colors {
      buttonColor
      buttonTextColor
    }
  }
  infoBanner {
    title
    font
    content
    buttonLabel
    buttonUrl
    colors {
      buttonBg
      background
      buttonLabel
      content
      title
    }
  }
  sensitive {
    type
  }
  seo {
    title
    description
  }
  favicon
}
    `;
export const QrFragmentDoc = gql`
    fragment Qr on QrModel {
  tags
  padding
  frame {
    id
    custom {
      type
      label
      labelColor
      frameColor1
      frameColor2
      frameColorType
      frameColorAngle
      labelSize
    }
  }
  module {
    id
    color {
      firstColor
      secondColor
      type
      angle
    }
  }
  eyes {
    lB {
      external
      externalId
      internalId
      internal
    }
    lT {
      external
      externalId
      internalId
      internal
    }
    rT {
      external
      externalId
      internalId
      internal
    }
  }
  shape {
    type
    bgColor {
      firstColor
      secondColor
      type
      angle
    }
    bgSize
    strokeColor {
      firstColor
      secondColor
      type
      angle
    }
    stroke
  }
  logo: _logo {
    hideBg
    margin
    size
    thumbnail
  }
  oldLogo: logo
}
    `;
export const LinkPropsFragmentDoc = gql`
    fragment LinkProps on LinkModel {
  id
  title
  url
  embeded
  embededIframe
  isActive
  priority
  order
  leapTime
  scheduleStart
  scheduleEnd
  scheduleTimezone
  thumbnail
  type
  childRow
  clicks
  isLinkValid @client
  isNew @client
  urlHolder @client
}
    `;
export const LinkFragmentDoc = gql`
    fragment Link on LinkModel {
  ...LinkProps
  children {
    rowId
    row {
      ...LinkProps
    }
  }
}
    ${LinkPropsFragmentDoc}`;
export const PageFragmentDoc = gql`
    fragment Page on PageModel {
  id
  pagename
  domainId
  domain {
    id
    domain
  }
  appearance {
    ...Appearance
  }
  settings {
    ...Settings
  }
  qr {
    ...Qr
  }
  links {
    ...Link
  }
}
    ${AppearanceFragmentDoc}
${SettingsFragmentDoc}
${QrFragmentDoc}
${LinkFragmentDoc}`;
export const SubscriptionPlanInfoFragmentDoc = gql`
    fragment SubscriptionPlanInfo on CustomerSubscription {
  id
  price_id
  end_date
  name
  price
  currency
  status
  canTrial
}
    `;
export const PersonalInfoFragmentDoc = gql`
    fragment PersonalInfo on Customer {
  fullName
  email
  timezone
}
    `;
export const IntegrationsFragmentDoc = gql`
    fragment Integrations on Customer {
  integrations {
    provider
    username
  }
}
    `;
export const ReportsFragmentDoc = gql`
    fragment Reports on CustomDashboard {
  reports {
    id
  }
}
    `;
export const TargetsPropsFragmentDoc = gql`
    fragment TargetsProps on SingleLinkTargetModel {
  id
  name
}
    `;
export const AdminSignInDocument = gql`
    mutation AdminSignIn($data: AdminLoginInput!) {
  adminLogin(data: $data) {
    accessToken
  }
}
    `;
export type AdminSignInMutationFn = Apollo.MutationFunction<AdminSignInMutation, AdminSignInMutationVariables>;

/**
 * __useAdminSignInMutation__
 *
 * To run a mutation, you first call `useAdminSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSignInMutation, { data, loading, error }] = useAdminSignInMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminSignInMutation(baseOptions?: Apollo.MutationHookOptions<AdminSignInMutation, AdminSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSignInMutation, AdminSignInMutationVariables>(AdminSignInDocument, options);
      }
export type AdminSignInMutationHookResult = ReturnType<typeof useAdminSignInMutation>;
export type AdminSignInMutationResult = Apollo.MutationResult<AdminSignInMutation>;
export type AdminSignInMutationOptions = Apollo.BaseMutationOptions<AdminSignInMutation, AdminSignInMutationVariables>;
export const MeAdminDocument = gql`
    query meAdmin {
  meAdmin {
    email
  }
}
    `;

/**
 * __useMeAdminQuery__
 *
 * To run a query within a React component, call `useMeAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeAdminQuery(baseOptions?: Apollo.QueryHookOptions<MeAdminQuery, MeAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeAdminQuery, MeAdminQueryVariables>(MeAdminDocument, options);
      }
export function useMeAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeAdminQuery, MeAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeAdminQuery, MeAdminQueryVariables>(MeAdminDocument, options);
        }
export type MeAdminQueryHookResult = ReturnType<typeof useMeAdminQuery>;
export type MeAdminLazyQueryHookResult = ReturnType<typeof useMeAdminLazyQuery>;
export type MeAdminQueryResult = Apollo.QueryResult<MeAdminQuery, MeAdminQueryVariables>;
export const AllCustomersDocument = gql`
    query allCustomers($offset: Int, $limit: Int) {
  allCustomers(offset: $offset, limit: $limit) {
    id
    customerPagesCount
    fullName
    email
    username
    createdAt
    subscriptionPlan {
      stripePlanId: id
      status
      plan: name
    }
  }
}
    `;

/**
 * __useAllCustomersQuery__
 *
 * To run a query within a React component, call `useAllCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCustomersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAllCustomersQuery(baseOptions?: Apollo.QueryHookOptions<AllCustomersQuery, AllCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCustomersQuery, AllCustomersQueryVariables>(AllCustomersDocument, options);
      }
export function useAllCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCustomersQuery, AllCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCustomersQuery, AllCustomersQueryVariables>(AllCustomersDocument, options);
        }
export type AllCustomersQueryHookResult = ReturnType<typeof useAllCustomersQuery>;
export type AllCustomersLazyQueryHookResult = ReturnType<typeof useAllCustomersLazyQuery>;
export type AllCustomersQueryResult = Apollo.QueryResult<AllCustomersQuery, AllCustomersQueryVariables>;
export const SearchCustomerDocument = gql`
    query searchCustomer($search: String!) {
  searchCustomer(search: $search) {
    id
    customerPagesCount
    fullName
    email
    username
    createdAt
    subscriptionPlan {
      stripePlanId: id
      status
      plan: name
    }
  }
}
    `;

/**
 * __useSearchCustomerQuery__
 *
 * To run a query within a React component, call `useSearchCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomerQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchCustomerQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomerQuery, SearchCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomerQuery, SearchCustomerQueryVariables>(SearchCustomerDocument, options);
      }
export function useSearchCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomerQuery, SearchCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomerQuery, SearchCustomerQueryVariables>(SearchCustomerDocument, options);
        }
export type SearchCustomerQueryHookResult = ReturnType<typeof useSearchCustomerQuery>;
export type SearchCustomerLazyQueryHookResult = ReturnType<typeof useSearchCustomerLazyQuery>;
export type SearchCustomerQueryResult = Apollo.QueryResult<SearchCustomerQuery, SearchCustomerQueryVariables>;
export const DeletingCustomersDocument = gql`
    query deletingCustomers {
  deletingCustomers {
    id
    email
    username
    deleteTime
  }
}
    `;

/**
 * __useDeletingCustomersQuery__
 *
 * To run a query within a React component, call `useDeletingCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeletingCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletingCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeletingCustomersQuery(baseOptions?: Apollo.QueryHookOptions<DeletingCustomersQuery, DeletingCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeletingCustomersQuery, DeletingCustomersQueryVariables>(DeletingCustomersDocument, options);
      }
export function useDeletingCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeletingCustomersQuery, DeletingCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeletingCustomersQuery, DeletingCustomersQueryVariables>(DeletingCustomersDocument, options);
        }
export type DeletingCustomersQueryHookResult = ReturnType<typeof useDeletingCustomersQuery>;
export type DeletingCustomersLazyQueryHookResult = ReturnType<typeof useDeletingCustomersLazyQuery>;
export type DeletingCustomersQueryResult = Apollo.QueryResult<DeletingCustomersQuery, DeletingCustomersQueryVariables>;
export const AllPromocodesDocument = gql`
    query allPromocodes($offset: Int, $limit: Int) {
  allPromocodes(offset: $offset, limit: $limit) {
    id
    value
    numberUses
    maxCustomer
    expiration
  }
}
    `;

/**
 * __useAllPromocodesQuery__
 *
 * To run a query within a React component, call `useAllPromocodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPromocodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPromocodesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAllPromocodesQuery(baseOptions?: Apollo.QueryHookOptions<AllPromocodesQuery, AllPromocodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPromocodesQuery, AllPromocodesQueryVariables>(AllPromocodesDocument, options);
      }
export function useAllPromocodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPromocodesQuery, AllPromocodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPromocodesQuery, AllPromocodesQueryVariables>(AllPromocodesDocument, options);
        }
export type AllPromocodesQueryHookResult = ReturnType<typeof useAllPromocodesQuery>;
export type AllPromocodesLazyQueryHookResult = ReturnType<typeof useAllPromocodesLazyQuery>;
export type AllPromocodesQueryResult = Apollo.QueryResult<AllPromocodesQuery, AllPromocodesQueryVariables>;
export const CustomersCountDocument = gql`
    query customersCount {
  getCountOfCustomers
}
    `;

/**
 * __useCustomersCountQuery__
 *
 * To run a query within a React component, call `useCustomersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomersCountQuery(baseOptions?: Apollo.QueryHookOptions<CustomersCountQuery, CustomersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersCountQuery, CustomersCountQueryVariables>(CustomersCountDocument, options);
      }
export function useCustomersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersCountQuery, CustomersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersCountQuery, CustomersCountQueryVariables>(CustomersCountDocument, options);
        }
export type CustomersCountQueryHookResult = ReturnType<typeof useCustomersCountQuery>;
export type CustomersCountLazyQueryHookResult = ReturnType<typeof useCustomersCountLazyQuery>;
export type CustomersCountQueryResult = Apollo.QueryResult<CustomersCountQuery, CustomersCountQueryVariables>;
export const CodesCountDocument = gql`
    query codesCount {
  getCountOfCodes
}
    `;

/**
 * __useCodesCountQuery__
 *
 * To run a query within a React component, call `useCodesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCodesCountQuery(baseOptions?: Apollo.QueryHookOptions<CodesCountQuery, CodesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CodesCountQuery, CodesCountQueryVariables>(CodesCountDocument, options);
      }
export function useCodesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CodesCountQuery, CodesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CodesCountQuery, CodesCountQueryVariables>(CodesCountDocument, options);
        }
export type CodesCountQueryHookResult = ReturnType<typeof useCodesCountQuery>;
export type CodesCountLazyQueryHookResult = ReturnType<typeof useCodesCountLazyQuery>;
export type CodesCountQueryResult = Apollo.QueryResult<CodesCountQuery, CodesCountQueryVariables>;
export const CustomerDetailDocument = gql`
    query customerDetail($username: String!) {
  customer(username: $username) {
    id
    username
    customerPagesListAdmin
    deleteTime
    blocked
    deleted
    subscriptionPlan {
      status
      price
      id
      plan: name
      end_date
      currency
      price_id
    }
  }
}
    `;

/**
 * __useCustomerDetailQuery__
 *
 * To run a query within a React component, call `useCustomerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerDetailQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useCustomerDetailQuery(baseOptions: Apollo.QueryHookOptions<CustomerDetailQuery, CustomerDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerDetailQuery, CustomerDetailQueryVariables>(CustomerDetailDocument, options);
      }
export function useCustomerDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerDetailQuery, CustomerDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerDetailQuery, CustomerDetailQueryVariables>(CustomerDetailDocument, options);
        }
export type CustomerDetailQueryHookResult = ReturnType<typeof useCustomerDetailQuery>;
export type CustomerDetailLazyQueryHookResult = ReturnType<typeof useCustomerDetailLazyQuery>;
export type CustomerDetailQueryResult = Apollo.QueryResult<CustomerDetailQuery, CustomerDetailQueryVariables>;
export const GetQrCodesDocument = gql`
    query getQrCodes($offset: Int, $limit: Int) {
  getQrCodes(offset: $offset, limit: $limit) {
    id
    owner
    url
    createdAt
  }
}
    `;

/**
 * __useGetQrCodesQuery__
 *
 * To run a query within a React component, call `useGetQrCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQrCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQrCodesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetQrCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetQrCodesQuery, GetQrCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQrCodesQuery, GetQrCodesQueryVariables>(GetQrCodesDocument, options);
      }
export function useGetQrCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQrCodesQuery, GetQrCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQrCodesQuery, GetQrCodesQueryVariables>(GetQrCodesDocument, options);
        }
export type GetQrCodesQueryHookResult = ReturnType<typeof useGetQrCodesQuery>;
export type GetQrCodesLazyQueryHookResult = ReturnType<typeof useGetQrCodesLazyQuery>;
export type GetQrCodesQueryResult = Apollo.QueryResult<GetQrCodesQuery, GetQrCodesQueryVariables>;
export const GetBioLinksDocument = gql`
    query getBioLinks($offset: Int, $limit: Int) {
  getBioLinks(offset: $offset, limit: $limit) {
    id
    owner
    url
    createdAt
  }
}
    `;

/**
 * __useGetBioLinksQuery__
 *
 * To run a query within a React component, call `useGetBioLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBioLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBioLinksQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBioLinksQuery(baseOptions?: Apollo.QueryHookOptions<GetBioLinksQuery, GetBioLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBioLinksQuery, GetBioLinksQueryVariables>(GetBioLinksDocument, options);
      }
export function useGetBioLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBioLinksQuery, GetBioLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBioLinksQuery, GetBioLinksQueryVariables>(GetBioLinksDocument, options);
        }
export type GetBioLinksQueryHookResult = ReturnType<typeof useGetBioLinksQuery>;
export type GetBioLinksLazyQueryHookResult = ReturnType<typeof useGetBioLinksLazyQuery>;
export type GetBioLinksQueryResult = Apollo.QueryResult<GetBioLinksQuery, GetBioLinksQueryVariables>;
export const SearchQrCodesDocument = gql`
    query searchQrCodes($search: String!) {
  searchQrCodes(search: $search) {
    id
    owner
    url
    createdAt
  }
}
    `;

/**
 * __useSearchQrCodesQuery__
 *
 * To run a query within a React component, call `useSearchQrCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQrCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQrCodesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchQrCodesQuery(baseOptions: Apollo.QueryHookOptions<SearchQrCodesQuery, SearchQrCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQrCodesQuery, SearchQrCodesQueryVariables>(SearchQrCodesDocument, options);
      }
export function useSearchQrCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQrCodesQuery, SearchQrCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQrCodesQuery, SearchQrCodesQueryVariables>(SearchQrCodesDocument, options);
        }
export type SearchQrCodesQueryHookResult = ReturnType<typeof useSearchQrCodesQuery>;
export type SearchQrCodesLazyQueryHookResult = ReturnType<typeof useSearchQrCodesLazyQuery>;
export type SearchQrCodesQueryResult = Apollo.QueryResult<SearchQrCodesQuery, SearchQrCodesQueryVariables>;
export const SearchBioLinksDocument = gql`
    query searchBioLinks($search: String!) {
  searchBioLinks(search: $search) {
    id
    owner
    url
    createdAt
  }
}
    `;

/**
 * __useSearchBioLinksQuery__
 *
 * To run a query within a React component, call `useSearchBioLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBioLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBioLinksQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchBioLinksQuery(baseOptions: Apollo.QueryHookOptions<SearchBioLinksQuery, SearchBioLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBioLinksQuery, SearchBioLinksQueryVariables>(SearchBioLinksDocument, options);
      }
export function useSearchBioLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBioLinksQuery, SearchBioLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBioLinksQuery, SearchBioLinksQueryVariables>(SearchBioLinksDocument, options);
        }
export type SearchBioLinksQueryHookResult = ReturnType<typeof useSearchBioLinksQuery>;
export type SearchBioLinksLazyQueryHookResult = ReturnType<typeof useSearchBioLinksLazyQuery>;
export type SearchBioLinksQueryResult = Apollo.QueryResult<SearchBioLinksQuery, SearchBioLinksQueryVariables>;
export const GetBioLinksCountDocument = gql`
    query getBioLinksCount {
  getBioLinksCount
}
    `;

/**
 * __useGetBioLinksCountQuery__
 *
 * To run a query within a React component, call `useGetBioLinksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBioLinksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBioLinksCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBioLinksCountQuery(baseOptions?: Apollo.QueryHookOptions<GetBioLinksCountQuery, GetBioLinksCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBioLinksCountQuery, GetBioLinksCountQueryVariables>(GetBioLinksCountDocument, options);
      }
export function useGetBioLinksCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBioLinksCountQuery, GetBioLinksCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBioLinksCountQuery, GetBioLinksCountQueryVariables>(GetBioLinksCountDocument, options);
        }
export type GetBioLinksCountQueryHookResult = ReturnType<typeof useGetBioLinksCountQuery>;
export type GetBioLinksCountLazyQueryHookResult = ReturnType<typeof useGetBioLinksCountLazyQuery>;
export type GetBioLinksCountQueryResult = Apollo.QueryResult<GetBioLinksCountQuery, GetBioLinksCountQueryVariables>;
export const GetQrCodesCountDocument = gql`
    query getQrCodesCount {
  getQrCodesCount
}
    `;

/**
 * __useGetQrCodesCountQuery__
 *
 * To run a query within a React component, call `useGetQrCodesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQrCodesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQrCodesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQrCodesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetQrCodesCountQuery, GetQrCodesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQrCodesCountQuery, GetQrCodesCountQueryVariables>(GetQrCodesCountDocument, options);
      }
export function useGetQrCodesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQrCodesCountQuery, GetQrCodesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQrCodesCountQuery, GetQrCodesCountQueryVariables>(GetQrCodesCountDocument, options);
        }
export type GetQrCodesCountQueryHookResult = ReturnType<typeof useGetQrCodesCountQuery>;
export type GetQrCodesCountLazyQueryHookResult = ReturnType<typeof useGetQrCodesCountLazyQuery>;
export type GetQrCodesCountQueryResult = Apollo.QueryResult<GetQrCodesCountQuery, GetQrCodesCountQueryVariables>;
export const UpdateDefaultPlanSettingDocument = gql`
    mutation updateDefaultPlanSetting($data: AuthSettingsDefaultPlanInput!) {
  updateDefaultPlanSetting(data: $data) {
    duration
    defaultPlanName
  }
}
    `;
export type UpdateDefaultPlanSettingMutationFn = Apollo.MutationFunction<UpdateDefaultPlanSettingMutation, UpdateDefaultPlanSettingMutationVariables>;

/**
 * __useUpdateDefaultPlanSettingMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultPlanSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultPlanSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultPlanSettingMutation, { data, loading, error }] = useUpdateDefaultPlanSettingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDefaultPlanSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultPlanSettingMutation, UpdateDefaultPlanSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultPlanSettingMutation, UpdateDefaultPlanSettingMutationVariables>(UpdateDefaultPlanSettingDocument, options);
      }
export type UpdateDefaultPlanSettingMutationHookResult = ReturnType<typeof useUpdateDefaultPlanSettingMutation>;
export type UpdateDefaultPlanSettingMutationResult = Apollo.MutationResult<UpdateDefaultPlanSettingMutation>;
export type UpdateDefaultPlanSettingMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultPlanSettingMutation, UpdateDefaultPlanSettingMutationVariables>;
export const DeleteQrCodeDocument = gql`
    mutation deleteQrCode($id: String!) {
  deleteQrCode(id: $id)
}
    `;
export type DeleteQrCodeMutationFn = Apollo.MutationFunction<DeleteQrCodeMutation, DeleteQrCodeMutationVariables>;

/**
 * __useDeleteQrCodeMutation__
 *
 * To run a mutation, you first call `useDeleteQrCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQrCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQrCodeMutation, { data, loading, error }] = useDeleteQrCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQrCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQrCodeMutation, DeleteQrCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQrCodeMutation, DeleteQrCodeMutationVariables>(DeleteQrCodeDocument, options);
      }
export type DeleteQrCodeMutationHookResult = ReturnType<typeof useDeleteQrCodeMutation>;
export type DeleteQrCodeMutationResult = Apollo.MutationResult<DeleteQrCodeMutation>;
export type DeleteQrCodeMutationOptions = Apollo.BaseMutationOptions<DeleteQrCodeMutation, DeleteQrCodeMutationVariables>;
export const DeleteBioLinkDocument = gql`
    mutation deleteBioLink($id: String!) {
  deleteBioLink(id: $id)
}
    `;
export type DeleteBioLinkMutationFn = Apollo.MutationFunction<DeleteBioLinkMutation, DeleteBioLinkMutationVariables>;

/**
 * __useDeleteBioLinkMutation__
 *
 * To run a mutation, you first call `useDeleteBioLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBioLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBioLinkMutation, { data, loading, error }] = useDeleteBioLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBioLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBioLinkMutation, DeleteBioLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBioLinkMutation, DeleteBioLinkMutationVariables>(DeleteBioLinkDocument, options);
      }
export type DeleteBioLinkMutationHookResult = ReturnType<typeof useDeleteBioLinkMutation>;
export type DeleteBioLinkMutationResult = Apollo.MutationResult<DeleteBioLinkMutation>;
export type DeleteBioLinkMutationOptions = Apollo.BaseMutationOptions<DeleteBioLinkMutation, DeleteBioLinkMutationVariables>;
export const GetSettingsDocument = gql`
    query getSettings {
  getSettings {
    authSettings {
      defaultPlan {
        duration
        defaultPlanName
      }
    }
  }
}
    `;

/**
 * __useGetSettingsQuery__
 *
 * To run a query within a React component, call `useGetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
      }
export function useGetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
        }
export type GetSettingsQueryHookResult = ReturnType<typeof useGetSettingsQuery>;
export type GetSettingsLazyQueryHookResult = ReturnType<typeof useGetSettingsLazyQuery>;
export type GetSettingsQueryResult = Apollo.QueryResult<GetSettingsQuery, GetSettingsQueryVariables>;
export const TopThreeStatsDocument = gql`
    query topThreeStats {
  topThreeStats {
    topByViews {
      title: pagename
      count: views
    }
    topByClicks {
      title: pagename
      count: clicks
    }
    topByLocations {
      title: city
      country
      state
      count: views
    }
  }
}
    `;

/**
 * __useTopThreeStatsQuery__
 *
 * To run a query within a React component, call `useTopThreeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopThreeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopThreeStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopThreeStatsQuery(baseOptions?: Apollo.QueryHookOptions<TopThreeStatsQuery, TopThreeStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopThreeStatsQuery, TopThreeStatsQueryVariables>(TopThreeStatsDocument, options);
      }
export function useTopThreeStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopThreeStatsQuery, TopThreeStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopThreeStatsQuery, TopThreeStatsQueryVariables>(TopThreeStatsDocument, options);
        }
export type TopThreeStatsQueryHookResult = ReturnType<typeof useTopThreeStatsQuery>;
export type TopThreeStatsLazyQueryHookResult = ReturnType<typeof useTopThreeStatsLazyQuery>;
export type TopThreeStatsQueryResult = Apollo.QueryResult<TopThreeStatsQuery, TopThreeStatsQueryVariables>;
export const WeekStatsDocument = gql`
    query weekStats {
  weekStats {
    day {
      clicks
      views
    }
    week {
      clicks
      views
    }
  }
}
    `;

/**
 * __useWeekStatsQuery__
 *
 * To run a query within a React component, call `useWeekStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeekStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeekStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeekStatsQuery(baseOptions?: Apollo.QueryHookOptions<WeekStatsQuery, WeekStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeekStatsQuery, WeekStatsQueryVariables>(WeekStatsDocument, options);
      }
export function useWeekStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeekStatsQuery, WeekStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeekStatsQuery, WeekStatsQueryVariables>(WeekStatsDocument, options);
        }
export type WeekStatsQueryHookResult = ReturnType<typeof useWeekStatsQuery>;
export type WeekStatsLazyQueryHookResult = ReturnType<typeof useWeekStatsLazyQuery>;
export type WeekStatsQueryResult = Apollo.QueryResult<WeekStatsQuery, WeekStatsQueryVariables>;
export const SnapshotChartsDocument = gql`
    query snapshotCharts($period: JoyqrStatPeriodType!) {
  snapshotCharts(period: $period) {
    day
    count
  }
}
    `;

/**
 * __useSnapshotChartsQuery__
 *
 * To run a query within a React component, call `useSnapshotChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnapshotChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnapshotChartsQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useSnapshotChartsQuery(baseOptions: Apollo.QueryHookOptions<SnapshotChartsQuery, SnapshotChartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SnapshotChartsQuery, SnapshotChartsQueryVariables>(SnapshotChartsDocument, options);
      }
export function useSnapshotChartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SnapshotChartsQuery, SnapshotChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SnapshotChartsQuery, SnapshotChartsQueryVariables>(SnapshotChartsDocument, options);
        }
export type SnapshotChartsQueryHookResult = ReturnType<typeof useSnapshotChartsQuery>;
export type SnapshotChartsLazyQueryHookResult = ReturnType<typeof useSnapshotChartsLazyQuery>;
export type SnapshotChartsQueryResult = Apollo.QueryResult<SnapshotChartsQuery, SnapshotChartsQueryVariables>;
export const AdminChartDocument = gql`
    query adminChart($type: AdminAnalyticsChartType!, $period: JoyqrStatPeriodType!) {
  chartData(type: $type, period: $period) {
    day
    count
  }
}
    `;

/**
 * __useAdminChartQuery__
 *
 * To run a query within a React component, call `useAdminChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminChartQuery({
 *   variables: {
 *      type: // value for 'type'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useAdminChartQuery(baseOptions: Apollo.QueryHookOptions<AdminChartQuery, AdminChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminChartQuery, AdminChartQueryVariables>(AdminChartDocument, options);
      }
export function useAdminChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminChartQuery, AdminChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminChartQuery, AdminChartQueryVariables>(AdminChartDocument, options);
        }
export type AdminChartQueryHookResult = ReturnType<typeof useAdminChartQuery>;
export type AdminChartLazyQueryHookResult = ReturnType<typeof useAdminChartLazyQuery>;
export type AdminChartQueryResult = Apollo.QueryResult<AdminChartQuery, AdminChartQueryVariables>;
export const ChangeBlockStateDocument = gql`
    mutation changeBlockState($userId: String!) {
  changeBlockState(userId: $userId) {
    id
    blocked
  }
}
    `;
export type ChangeBlockStateMutationFn = Apollo.MutationFunction<ChangeBlockStateMutation, ChangeBlockStateMutationVariables>;

/**
 * __useChangeBlockStateMutation__
 *
 * To run a mutation, you first call `useChangeBlockStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeBlockStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeBlockStateMutation, { data, loading, error }] = useChangeBlockStateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChangeBlockStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeBlockStateMutation, ChangeBlockStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeBlockStateMutation, ChangeBlockStateMutationVariables>(ChangeBlockStateDocument, options);
      }
export type ChangeBlockStateMutationHookResult = ReturnType<typeof useChangeBlockStateMutation>;
export type ChangeBlockStateMutationResult = Apollo.MutationResult<ChangeBlockStateMutation>;
export type ChangeBlockStateMutationOptions = Apollo.BaseMutationOptions<ChangeBlockStateMutation, ChangeBlockStateMutationVariables>;
export const CreatePromocodeDocument = gql`
    mutation createPromocode($promocode: CreatePromocodeInput!) {
  createPromocode(data: $promocode) {
    value
    numberUses
    maxCustomer
    expiration
  }
}
    `;
export type CreatePromocodeMutationFn = Apollo.MutationFunction<CreatePromocodeMutation, CreatePromocodeMutationVariables>;

/**
 * __useCreatePromocodeMutation__
 *
 * To run a mutation, you first call `useCreatePromocodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePromocodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPromocodeMutation, { data, loading, error }] = useCreatePromocodeMutation({
 *   variables: {
 *      promocode: // value for 'promocode'
 *   },
 * });
 */
export function useCreatePromocodeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePromocodeMutation, CreatePromocodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePromocodeMutation, CreatePromocodeMutationVariables>(CreatePromocodeDocument, options);
      }
export type CreatePromocodeMutationHookResult = ReturnType<typeof useCreatePromocodeMutation>;
export type CreatePromocodeMutationResult = Apollo.MutationResult<CreatePromocodeMutation>;
export type CreatePromocodeMutationOptions = Apollo.BaseMutationOptions<CreatePromocodeMutation, CreatePromocodeMutationVariables>;
export const CreateRandomPromocodeDocument = gql`
    mutation createRandomPromocode($promocode: CreateRandomPromocodeInput!) {
  createRandomPromocodes(data: $promocode)
}
    `;
export type CreateRandomPromocodeMutationFn = Apollo.MutationFunction<CreateRandomPromocodeMutation, CreateRandomPromocodeMutationVariables>;

/**
 * __useCreateRandomPromocodeMutation__
 *
 * To run a mutation, you first call `useCreateRandomPromocodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRandomPromocodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRandomPromocodeMutation, { data, loading, error }] = useCreateRandomPromocodeMutation({
 *   variables: {
 *      promocode: // value for 'promocode'
 *   },
 * });
 */
export function useCreateRandomPromocodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateRandomPromocodeMutation, CreateRandomPromocodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRandomPromocodeMutation, CreateRandomPromocodeMutationVariables>(CreateRandomPromocodeDocument, options);
      }
export type CreateRandomPromocodeMutationHookResult = ReturnType<typeof useCreateRandomPromocodeMutation>;
export type CreateRandomPromocodeMutationResult = Apollo.MutationResult<CreateRandomPromocodeMutation>;
export type CreateRandomPromocodeMutationOptions = Apollo.BaseMutationOptions<CreateRandomPromocodeMutation, CreateRandomPromocodeMutationVariables>;
export const UpdatePromocodeDocument = gql`
    mutation updatePromocode($promocode: UpdatePromocodeInput!) {
  updatePromocode(data: $promocode) {
    id
    value
    numberUses
    maxCustomer
    expiration
  }
}
    `;
export type UpdatePromocodeMutationFn = Apollo.MutationFunction<UpdatePromocodeMutation, UpdatePromocodeMutationVariables>;

/**
 * __useUpdatePromocodeMutation__
 *
 * To run a mutation, you first call `useUpdatePromocodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePromocodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePromocodeMutation, { data, loading, error }] = useUpdatePromocodeMutation({
 *   variables: {
 *      promocode: // value for 'promocode'
 *   },
 * });
 */
export function useUpdatePromocodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePromocodeMutation, UpdatePromocodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePromocodeMutation, UpdatePromocodeMutationVariables>(UpdatePromocodeDocument, options);
      }
export type UpdatePromocodeMutationHookResult = ReturnType<typeof useUpdatePromocodeMutation>;
export type UpdatePromocodeMutationResult = Apollo.MutationResult<UpdatePromocodeMutation>;
export type UpdatePromocodeMutationOptions = Apollo.BaseMutationOptions<UpdatePromocodeMutation, UpdatePromocodeMutationVariables>;
export const UpdateSubscriptionAdminDocument = gql`
    mutation updateSubscriptionAdmin($plan: UpdateCustomerSubscription!) {
  updateSubscriptionAdmin(data: $plan)
}
    `;
export type UpdateSubscriptionAdminMutationFn = Apollo.MutationFunction<UpdateSubscriptionAdminMutation, UpdateSubscriptionAdminMutationVariables>;

/**
 * __useUpdateSubscriptionAdminMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionAdminMutation, { data, loading, error }] = useUpdateSubscriptionAdminMutation({
 *   variables: {
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useUpdateSubscriptionAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionAdminMutation, UpdateSubscriptionAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionAdminMutation, UpdateSubscriptionAdminMutationVariables>(UpdateSubscriptionAdminDocument, options);
      }
export type UpdateSubscriptionAdminMutationHookResult = ReturnType<typeof useUpdateSubscriptionAdminMutation>;
export type UpdateSubscriptionAdminMutationResult = Apollo.MutationResult<UpdateSubscriptionAdminMutation>;
export type UpdateSubscriptionAdminMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionAdminMutation, UpdateSubscriptionAdminMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($userId: String!) {
  deleteUser(userId: $userId)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($data: LoginInput!) {
  login(data: $data) {
    accessToken
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($data: SignupInput!) {
  signup(data: $data) {
    accessToken
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const CreateCustomDashboardDocument = gql`
    mutation createCustomDashboard($name: String!) {
  createCustomDashboard(name: $name) {
    id
    title
  }
}
    `;
export type CreateCustomDashboardMutationFn = Apollo.MutationFunction<CreateCustomDashboardMutation, CreateCustomDashboardMutationVariables>;

/**
 * __useCreateCustomDashboardMutation__
 *
 * To run a mutation, you first call `useCreateCustomDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomDashboardMutation, { data, loading, error }] = useCreateCustomDashboardMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateCustomDashboardMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomDashboardMutation, CreateCustomDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomDashboardMutation, CreateCustomDashboardMutationVariables>(CreateCustomDashboardDocument, options);
      }
export type CreateCustomDashboardMutationHookResult = ReturnType<typeof useCreateCustomDashboardMutation>;
export type CreateCustomDashboardMutationResult = Apollo.MutationResult<CreateCustomDashboardMutation>;
export type CreateCustomDashboardMutationOptions = Apollo.BaseMutationOptions<CreateCustomDashboardMutation, CreateCustomDashboardMutationVariables>;
export const CreateCustomReportDocument = gql`
    mutation createCustomReport($data: CustomReportInput!) {
  createCustomReport(data: $data) {
    id
    config
  }
}
    `;
export type CreateCustomReportMutationFn = Apollo.MutationFunction<CreateCustomReportMutation, CreateCustomReportMutationVariables>;

/**
 * __useCreateCustomReportMutation__
 *
 * To run a mutation, you first call `useCreateCustomReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomReportMutation, { data, loading, error }] = useCreateCustomReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomReportMutation, CreateCustomReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomReportMutation, CreateCustomReportMutationVariables>(CreateCustomReportDocument, options);
      }
export type CreateCustomReportMutationHookResult = ReturnType<typeof useCreateCustomReportMutation>;
export type CreateCustomReportMutationResult = Apollo.MutationResult<CreateCustomReportMutation>;
export type CreateCustomReportMutationOptions = Apollo.BaseMutationOptions<CreateCustomReportMutation, CreateCustomReportMutationVariables>;
export const UpdateDashboardGridDocument = gql`
    mutation updateDashboardGrid($dashboardId: String!, $data: [CustomReportUpdatePositionInput!]!) {
  updateDashboardGrid(dashboardId: $dashboardId, data: $data)
}
    `;
export type UpdateDashboardGridMutationFn = Apollo.MutationFunction<UpdateDashboardGridMutation, UpdateDashboardGridMutationVariables>;

/**
 * __useUpdateDashboardGridMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardGridMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardGridMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardGridMutation, { data, loading, error }] = useUpdateDashboardGridMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDashboardGridMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDashboardGridMutation, UpdateDashboardGridMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDashboardGridMutation, UpdateDashboardGridMutationVariables>(UpdateDashboardGridDocument, options);
      }
export type UpdateDashboardGridMutationHookResult = ReturnType<typeof useUpdateDashboardGridMutation>;
export type UpdateDashboardGridMutationResult = Apollo.MutationResult<UpdateDashboardGridMutation>;
export type UpdateDashboardGridMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardGridMutation, UpdateDashboardGridMutationVariables>;
export const FiltersDocument = gql`
    query filters($filter: String!) {
  filters(filter: $filter)
}
    `;

/**
 * __useFiltersQuery__
 *
 * To run a query within a React component, call `useFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiltersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFiltersQuery(baseOptions: Apollo.QueryHookOptions<FiltersQuery, FiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiltersQuery, FiltersQueryVariables>(FiltersDocument, options);
      }
export function useFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiltersQuery, FiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiltersQuery, FiltersQueryVariables>(FiltersDocument, options);
        }
export type FiltersQueryHookResult = ReturnType<typeof useFiltersQuery>;
export type FiltersLazyQueryHookResult = ReturnType<typeof useFiltersLazyQuery>;
export type FiltersQueryResult = Apollo.QueryResult<FiltersQuery, FiltersQueryVariables>;
export const CustomDashboardsDocument = gql`
    query customDashboards {
  customDashboards {
    id
    title
    ...Reports
  }
}
    ${ReportsFragmentDoc}`;

/**
 * __useCustomDashboardsQuery__
 *
 * To run a query within a React component, call `useCustomDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDashboardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomDashboardsQuery(baseOptions?: Apollo.QueryHookOptions<CustomDashboardsQuery, CustomDashboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomDashboardsQuery, CustomDashboardsQueryVariables>(CustomDashboardsDocument, options);
      }
export function useCustomDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomDashboardsQuery, CustomDashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomDashboardsQuery, CustomDashboardsQueryVariables>(CustomDashboardsDocument, options);
        }
export type CustomDashboardsQueryHookResult = ReturnType<typeof useCustomDashboardsQuery>;
export type CustomDashboardsLazyQueryHookResult = ReturnType<typeof useCustomDashboardsLazyQuery>;
export type CustomDashboardsQueryResult = Apollo.QueryResult<CustomDashboardsQuery, CustomDashboardsQueryVariables>;
export const DeleteReportDocument = gql`
    mutation deleteReport($reportId: String!) {
  deleteReport(reportId: $reportId)
}
    `;
export type DeleteReportMutationFn = Apollo.MutationFunction<DeleteReportMutation, DeleteReportMutationVariables>;

/**
 * __useDeleteReportMutation__
 *
 * To run a mutation, you first call `useDeleteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportMutation, { data, loading, error }] = useDeleteReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useDeleteReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportMutation, DeleteReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportMutation, DeleteReportMutationVariables>(DeleteReportDocument, options);
      }
export type DeleteReportMutationHookResult = ReturnType<typeof useDeleteReportMutation>;
export type DeleteReportMutationResult = Apollo.MutationResult<DeleteReportMutation>;
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<DeleteReportMutation, DeleteReportMutationVariables>;
export const UpdateDashboardNameDocument = gql`
    mutation updateDashboardName($dashboardId: String!, $dashboardName: String!) {
  updateDashboardName(dashboardId: $dashboardId, dashboardName: $dashboardName)
}
    `;
export type UpdateDashboardNameMutationFn = Apollo.MutationFunction<UpdateDashboardNameMutation, UpdateDashboardNameMutationVariables>;

/**
 * __useUpdateDashboardNameMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardNameMutation, { data, loading, error }] = useUpdateDashboardNameMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *      dashboardName: // value for 'dashboardName'
 *   },
 * });
 */
export function useUpdateDashboardNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDashboardNameMutation, UpdateDashboardNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDashboardNameMutation, UpdateDashboardNameMutationVariables>(UpdateDashboardNameDocument, options);
      }
export type UpdateDashboardNameMutationHookResult = ReturnType<typeof useUpdateDashboardNameMutation>;
export type UpdateDashboardNameMutationResult = Apollo.MutationResult<UpdateDashboardNameMutation>;
export type UpdateDashboardNameMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardNameMutation, UpdateDashboardNameMutationVariables>;
export const DeleteDashboardDocument = gql`
    mutation deleteDashboard($dashboardId: String!) {
  deleteDashboard(dashboardId: $dashboardId)
}
    `;
export type DeleteDashboardMutationFn = Apollo.MutationFunction<DeleteDashboardMutation, DeleteDashboardMutationVariables>;

/**
 * __useDeleteDashboardMutation__
 *
 * To run a mutation, you first call `useDeleteDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDashboardMutation, { data, loading, error }] = useDeleteDashboardMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useDeleteDashboardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDashboardMutation, DeleteDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDashboardMutation, DeleteDashboardMutationVariables>(DeleteDashboardDocument, options);
      }
export type DeleteDashboardMutationHookResult = ReturnType<typeof useDeleteDashboardMutation>;
export type DeleteDashboardMutationResult = Apollo.MutationResult<DeleteDashboardMutation>;
export type DeleteDashboardMutationOptions = Apollo.BaseMutationOptions<DeleteDashboardMutation, DeleteDashboardMutationVariables>;
export const ReportDocument = gql`
    query report($reportId: String!) {
  report(reportId: $reportId) {
    id
    title
    series {
      metricId
      serie {
        date
        count
        city
        state
        country
        day
        part
        os
        device
        title
      }
    }
    config
  }
}
    `;

/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportQuery(baseOptions: Apollo.QueryHookOptions<ReportQuery, ReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
      }
export function useReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportQuery, ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
        }
export type ReportQueryHookResult = ReturnType<typeof useReportQuery>;
export type ReportLazyQueryHookResult = ReturnType<typeof useReportLazyQuery>;
export type ReportQueryResult = Apollo.QueryResult<ReportQuery, ReportQueryVariables>;
export const CustomDashboardEventsDocument = gql`
    query customDashboardEvents {
  customDashboardEvents {
    pageViews {
      id
      title
    }
    linkClicks {
      id
      title
    }
    socialLinkClicks {
      id
      title
    }
    qrScans {
      id
      title
    }
    targetScans {
      id
      title
    }
  }
}
    `;

/**
 * __useCustomDashboardEventsQuery__
 *
 * To run a query within a React component, call `useCustomDashboardEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomDashboardEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDashboardEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomDashboardEventsQuery(baseOptions?: Apollo.QueryHookOptions<CustomDashboardEventsQuery, CustomDashboardEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomDashboardEventsQuery, CustomDashboardEventsQueryVariables>(CustomDashboardEventsDocument, options);
      }
export function useCustomDashboardEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomDashboardEventsQuery, CustomDashboardEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomDashboardEventsQuery, CustomDashboardEventsQueryVariables>(CustomDashboardEventsDocument, options);
        }
export type CustomDashboardEventsQueryHookResult = ReturnType<typeof useCustomDashboardEventsQuery>;
export type CustomDashboardEventsLazyQueryHookResult = ReturnType<typeof useCustomDashboardEventsLazyQuery>;
export type CustomDashboardEventsQueryResult = Apollo.QueryResult<CustomDashboardEventsQuery, CustomDashboardEventsQueryVariables>;
export const EventDataDocument = gql`
    query eventData($event: String!, $itemId: String!, $type: String!, $date: DateInterval!, $filters: [QueryFilter!], $groups: [GroupByFilter!]) {
  eventData(
    event: $event
    itemId: $itemId
    type: $type
    date: $date
    filters: $filters
    groupBy: $groups
  ) {
    date
    count
    city
    state
    country
    day
    part
    os
    device
    title
  }
}
    `;

/**
 * __useEventDataQuery__
 *
 * To run a query within a React component, call `useEventDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDataQuery({
 *   variables: {
 *      event: // value for 'event'
 *      itemId: // value for 'itemId'
 *      type: // value for 'type'
 *      date: // value for 'date'
 *      filters: // value for 'filters'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useEventDataQuery(baseOptions: Apollo.QueryHookOptions<EventDataQuery, EventDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventDataQuery, EventDataQueryVariables>(EventDataDocument, options);
      }
export function useEventDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventDataQuery, EventDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventDataQuery, EventDataQueryVariables>(EventDataDocument, options);
        }
export type EventDataQueryHookResult = ReturnType<typeof useEventDataQuery>;
export type EventDataLazyQueryHookResult = ReturnType<typeof useEventDataLazyQuery>;
export type EventDataQueryResult = Apollo.QueryResult<EventDataQuery, EventDataQueryVariables>;
export const CustomDashboardDocument = gql`
    query customDashboard($dashboardId: String!) {
  dashboard(dashboardId: $dashboardId) {
    id
    title
    reports {
      id
      title
      series {
        metricId
        serie {
          date
          count
          city
          state
          country
          day
          part
          os
          title
          device
        }
      }
      config
    }
  }
}
    `;

/**
 * __useCustomDashboardQuery__
 *
 * To run a query within a React component, call `useCustomDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDashboardQuery({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useCustomDashboardQuery(baseOptions: Apollo.QueryHookOptions<CustomDashboardQuery, CustomDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomDashboardQuery, CustomDashboardQueryVariables>(CustomDashboardDocument, options);
      }
export function useCustomDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomDashboardQuery, CustomDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomDashboardQuery, CustomDashboardQueryVariables>(CustomDashboardDocument, options);
        }
export type CustomDashboardQueryHookResult = ReturnType<typeof useCustomDashboardQuery>;
export type CustomDashboardLazyQueryHookResult = ReturnType<typeof useCustomDashboardLazyQuery>;
export type CustomDashboardQueryResult = Apollo.QueryResult<CustomDashboardQuery, CustomDashboardQueryVariables>;
export const CreateEmailSubscriberDocument = gql`
    mutation createEmailSubscriber($data: CreateEmailSubscriber!) {
  createEmailSubscriber(data: $data)
}
    `;
export type CreateEmailSubscriberMutationFn = Apollo.MutationFunction<CreateEmailSubscriberMutation, CreateEmailSubscriberMutationVariables>;

/**
 * __useCreateEmailSubscriberMutation__
 *
 * To run a mutation, you first call `useCreateEmailSubscriberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailSubscriberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailSubscriberMutation, { data, loading, error }] = useCreateEmailSubscriberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmailSubscriberMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailSubscriberMutation, CreateEmailSubscriberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailSubscriberMutation, CreateEmailSubscriberMutationVariables>(CreateEmailSubscriberDocument, options);
      }
export type CreateEmailSubscriberMutationHookResult = ReturnType<typeof useCreateEmailSubscriberMutation>;
export type CreateEmailSubscriberMutationResult = Apollo.MutationResult<CreateEmailSubscriberMutation>;
export type CreateEmailSubscriberMutationOptions = Apollo.BaseMutationOptions<CreateEmailSubscriberMutation, CreateEmailSubscriberMutationVariables>;
export const CreateSmsSubscriberDocument = gql`
    mutation createSmsSubscriber($data: CreateSmsSubscriber!) {
  createSmsSubscriber(data: $data)
}
    `;
export type CreateSmsSubscriberMutationFn = Apollo.MutationFunction<CreateSmsSubscriberMutation, CreateSmsSubscriberMutationVariables>;

/**
 * __useCreateSmsSubscriberMutation__
 *
 * To run a mutation, you first call `useCreateSmsSubscriberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSmsSubscriberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSmsSubscriberMutation, { data, loading, error }] = useCreateSmsSubscriberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSmsSubscriberMutation(baseOptions?: Apollo.MutationHookOptions<CreateSmsSubscriberMutation, CreateSmsSubscriberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSmsSubscriberMutation, CreateSmsSubscriberMutationVariables>(CreateSmsSubscriberDocument, options);
      }
export type CreateSmsSubscriberMutationHookResult = ReturnType<typeof useCreateSmsSubscriberMutation>;
export type CreateSmsSubscriberMutationResult = Apollo.MutationResult<CreateSmsSubscriberMutation>;
export type CreateSmsSubscriberMutationOptions = Apollo.BaseMutationOptions<CreateSmsSubscriberMutation, CreateSmsSubscriberMutationVariables>;
export const AnalyticEventDocument = gql`
    mutation analyticEvent($data: AnalyticEventInput!) {
  analyticEvent(data: $data)
}
    `;
export type AnalyticEventMutationFn = Apollo.MutationFunction<AnalyticEventMutation, AnalyticEventMutationVariables>;

/**
 * __useAnalyticEventMutation__
 *
 * To run a mutation, you first call `useAnalyticEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticEventMutation, { data, loading, error }] = useAnalyticEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAnalyticEventMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticEventMutation, AnalyticEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticEventMutation, AnalyticEventMutationVariables>(AnalyticEventDocument, options);
      }
export type AnalyticEventMutationHookResult = ReturnType<typeof useAnalyticEventMutation>;
export type AnalyticEventMutationResult = Apollo.MutationResult<AnalyticEventMutation>;
export type AnalyticEventMutationOptions = Apollo.BaseMutationOptions<AnalyticEventMutation, AnalyticEventMutationVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    createdAt
    username
    customerPagesList
    selectedFeature
    deleted
    avatar
    active
    ...PersonalInfo
    subscriptionPlan {
      ...SubscriptionPlanInfo
    }
    page {
      ...Page
    }
    ...Integrations
  }
}
    ${PersonalInfoFragmentDoc}
${SubscriptionPlanInfoFragmentDoc}
${PageFragmentDoc}
${IntegrationsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const CheckUsernameDocument = gql`
    query checkUsername($username: String!) {
  checkUsername(username: $username)
}
    `;

/**
 * __useCheckUsernameQuery__
 *
 * To run a query within a React component, call `useCheckUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useCheckUsernameQuery(baseOptions: Apollo.QueryHookOptions<CheckUsernameQuery, CheckUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUsernameQuery, CheckUsernameQueryVariables>(CheckUsernameDocument, options);
      }
export function useCheckUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUsernameQuery, CheckUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUsernameQuery, CheckUsernameQueryVariables>(CheckUsernameDocument, options);
        }
export type CheckUsernameQueryHookResult = ReturnType<typeof useCheckUsernameQuery>;
export type CheckUsernameLazyQueryHookResult = ReturnType<typeof useCheckUsernameLazyQuery>;
export type CheckUsernameQueryResult = Apollo.QueryResult<CheckUsernameQuery, CheckUsernameQueryVariables>;
export const MePersonalInfoDocument = gql`
    query mePersonalInfo {
  me {
    ...PersonalInfo
  }
}
    ${PersonalInfoFragmentDoc}`;

/**
 * __useMePersonalInfoQuery__
 *
 * To run a query within a React component, call `useMePersonalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMePersonalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMePersonalInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMePersonalInfoQuery(baseOptions?: Apollo.QueryHookOptions<MePersonalInfoQuery, MePersonalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MePersonalInfoQuery, MePersonalInfoQueryVariables>(MePersonalInfoDocument, options);
      }
export function useMePersonalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MePersonalInfoQuery, MePersonalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MePersonalInfoQuery, MePersonalInfoQueryVariables>(MePersonalInfoDocument, options);
        }
export type MePersonalInfoQueryHookResult = ReturnType<typeof useMePersonalInfoQuery>;
export type MePersonalInfoLazyQueryHookResult = ReturnType<typeof useMePersonalInfoLazyQuery>;
export type MePersonalInfoQueryResult = Apollo.QueryResult<MePersonalInfoQuery, MePersonalInfoQueryVariables>;
export const EmbeddedDocument = gql`
    query embedded($url: String!) {
  embeded(url: $url)
}
    `;

/**
 * __useEmbeddedQuery__
 *
 * To run a query within a React component, call `useEmbeddedQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbeddedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbeddedQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useEmbeddedQuery(baseOptions: Apollo.QueryHookOptions<EmbeddedQuery, EmbeddedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmbeddedQuery, EmbeddedQueryVariables>(EmbeddedDocument, options);
      }
export function useEmbeddedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmbeddedQuery, EmbeddedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmbeddedQuery, EmbeddedQueryVariables>(EmbeddedDocument, options);
        }
export type EmbeddedQueryHookResult = ReturnType<typeof useEmbeddedQuery>;
export type EmbeddedLazyQueryHookResult = ReturnType<typeof useEmbeddedLazyQuery>;
export type EmbeddedQueryResult = Apollo.QueryResult<EmbeddedQuery, EmbeddedQueryVariables>;
export const UnsplashPhotoDocument = gql`
    query unsplashPhoto($search: String!) {
  getUnsplashPhotos(search: $search) {
    downloadLocation
    autor {
      name
      unsplashLink
    }
    rawUrl
  }
}
    `;

/**
 * __useUnsplashPhotoQuery__
 *
 * To run a query within a React component, call `useUnsplashPhotoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnsplashPhotoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnsplashPhotoQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUnsplashPhotoQuery(baseOptions: Apollo.QueryHookOptions<UnsplashPhotoQuery, UnsplashPhotoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnsplashPhotoQuery, UnsplashPhotoQueryVariables>(UnsplashPhotoDocument, options);
      }
export function useUnsplashPhotoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnsplashPhotoQuery, UnsplashPhotoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnsplashPhotoQuery, UnsplashPhotoQueryVariables>(UnsplashPhotoDocument, options);
        }
export type UnsplashPhotoQueryHookResult = ReturnType<typeof useUnsplashPhotoQuery>;
export type UnsplashPhotoLazyQueryHookResult = ReturnType<typeof useUnsplashPhotoLazyQuery>;
export type UnsplashPhotoQueryResult = Apollo.QueryResult<UnsplashPhotoQuery, UnsplashPhotoQueryVariables>;
export const SelectFeatureDocument = gql`
    mutation selectFeature($feature: SelectedFeature!) {
  selectFeature(feature: $feature)
}
    `;
export type SelectFeatureMutationFn = Apollo.MutationFunction<SelectFeatureMutation, SelectFeatureMutationVariables>;

/**
 * __useSelectFeatureMutation__
 *
 * To run a mutation, you first call `useSelectFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectFeatureMutation, { data, loading, error }] = useSelectFeatureMutation({
 *   variables: {
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useSelectFeatureMutation(baseOptions?: Apollo.MutationHookOptions<SelectFeatureMutation, SelectFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectFeatureMutation, SelectFeatureMutationVariables>(SelectFeatureDocument, options);
      }
export type SelectFeatureMutationHookResult = ReturnType<typeof useSelectFeatureMutation>;
export type SelectFeatureMutationResult = Apollo.MutationResult<SelectFeatureMutation>;
export type SelectFeatureMutationOptions = Apollo.BaseMutationOptions<SelectFeatureMutation, SelectFeatureMutationVariables>;
export const CreatePageDocument = gql`
    mutation createPage($pagename: String!) {
  createPage(pagename: $pagename) {
    ...Page
  }
}
    ${PageFragmentDoc}`;
export type CreatePageMutationFn = Apollo.MutationFunction<CreatePageMutation, CreatePageMutationVariables>;

/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      pagename: // value for 'pagename'
 *   },
 * });
 */
export function useCreatePageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageMutation, CreatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageMutation, CreatePageMutationVariables>(CreatePageDocument, options);
      }
export type CreatePageMutationHookResult = ReturnType<typeof useCreatePageMutation>;
export type CreatePageMutationResult = Apollo.MutationResult<CreatePageMutation>;
export type CreatePageMutationOptions = Apollo.BaseMutationOptions<CreatePageMutation, CreatePageMutationVariables>;
export const SelectPageDocument = gql`
    mutation selectPage($pageId: String!) {
  selectPage(pageId: $pageId) {
    ...Page
  }
}
    ${PageFragmentDoc}`;
export type SelectPageMutationFn = Apollo.MutationFunction<SelectPageMutation, SelectPageMutationVariables>;

/**
 * __useSelectPageMutation__
 *
 * To run a mutation, you first call `useSelectPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectPageMutation, { data, loading, error }] = useSelectPageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useSelectPageMutation(baseOptions?: Apollo.MutationHookOptions<SelectPageMutation, SelectPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectPageMutation, SelectPageMutationVariables>(SelectPageDocument, options);
      }
export type SelectPageMutationHookResult = ReturnType<typeof useSelectPageMutation>;
export type SelectPageMutationResult = Apollo.MutationResult<SelectPageMutation>;
export type SelectPageMutationOptions = Apollo.BaseMutationOptions<SelectPageMutation, SelectPageMutationVariables>;
export const DeletePageDocument = gql`
    mutation deletePage($pageId: String!) {
  deletePage(pageId: $pageId)
}
    `;
export type DeletePageMutationFn = Apollo.MutationFunction<DeletePageMutation, DeletePageMutationVariables>;

/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageMutation, { data, loading, error }] = useDeletePageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeletePageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePageMutation, DeletePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePageMutation, DeletePageMutationVariables>(DeletePageDocument, options);
      }
export type DeletePageMutationHookResult = ReturnType<typeof useDeletePageMutation>;
export type DeletePageMutationResult = Apollo.MutationResult<DeletePageMutation>;
export type DeletePageMutationOptions = Apollo.BaseMutationOptions<DeletePageMutation, DeletePageMutationVariables>;
export const UpdateMeDocument = gql`
    mutation updateMe($data: UpdateUserInput!) {
  updateUser(data: $data) {
    id
    username
    ...PersonalInfo
  }
}
    ${PersonalInfoFragmentDoc}`;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($data: ChangePasswordInput!) {
  changePassword(data: $data) {
    id
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($token: String!, $password: String!) {
  resetPassword(token: $token, password: $password)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const DeleteMeDocument = gql`
    mutation deleteMe {
  deleteMe
}
    `;
export type DeleteMeMutationFn = Apollo.MutationFunction<DeleteMeMutation, DeleteMeMutationVariables>;

/**
 * __useDeleteMeMutation__
 *
 * To run a mutation, you first call `useDeleteMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeMutation, { data, loading, error }] = useDeleteMeMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMeMutation, DeleteMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMeMutation, DeleteMeMutationVariables>(DeleteMeDocument, options);
      }
export type DeleteMeMutationHookResult = ReturnType<typeof useDeleteMeMutation>;
export type DeleteMeMutationResult = Apollo.MutationResult<DeleteMeMutation>;
export type DeleteMeMutationOptions = Apollo.BaseMutationOptions<DeleteMeMutation, DeleteMeMutationVariables>;
export const CancelDeleteDocument = gql`
    mutation cancelDelete {
  cancelDelete
}
    `;
export type CancelDeleteMutationFn = Apollo.MutationFunction<CancelDeleteMutation, CancelDeleteMutationVariables>;

/**
 * __useCancelDeleteMutation__
 *
 * To run a mutation, you first call `useCancelDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDeleteMutation, { data, loading, error }] = useCancelDeleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CancelDeleteMutation, CancelDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDeleteMutation, CancelDeleteMutationVariables>(CancelDeleteDocument, options);
      }
export type CancelDeleteMutationHookResult = ReturnType<typeof useCancelDeleteMutation>;
export type CancelDeleteMutationResult = Apollo.MutationResult<CancelDeleteMutation>;
export type CancelDeleteMutationOptions = Apollo.BaseMutationOptions<CancelDeleteMutation, CancelDeleteMutationVariables>;
export const CreateQrTagDocument = gql`
    mutation createQrTag($tag: String!) {
  createQrTag(tag: $tag)
}
    `;
export type CreateQrTagMutationFn = Apollo.MutationFunction<CreateQrTagMutation, CreateQrTagMutationVariables>;

/**
 * __useCreateQrTagMutation__
 *
 * To run a mutation, you first call `useCreateQrTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQrTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQrTagMutation, { data, loading, error }] = useCreateQrTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useCreateQrTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateQrTagMutation, CreateQrTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQrTagMutation, CreateQrTagMutationVariables>(CreateQrTagDocument, options);
      }
export type CreateQrTagMutationHookResult = ReturnType<typeof useCreateQrTagMutation>;
export type CreateQrTagMutationResult = Apollo.MutationResult<CreateQrTagMutation>;
export type CreateQrTagMutationOptions = Apollo.BaseMutationOptions<CreateQrTagMutation, CreateQrTagMutationVariables>;
export const DeleteQrTagDocument = gql`
    mutation deleteQrTag($tag: String!) {
  deleteQrTag(tag: $tag)
}
    `;
export type DeleteQrTagMutationFn = Apollo.MutationFunction<DeleteQrTagMutation, DeleteQrTagMutationVariables>;

/**
 * __useDeleteQrTagMutation__
 *
 * To run a mutation, you first call `useDeleteQrTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQrTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQrTagMutation, { data, loading, error }] = useDeleteQrTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useDeleteQrTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQrTagMutation, DeleteQrTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQrTagMutation, DeleteQrTagMutationVariables>(DeleteQrTagDocument, options);
      }
export type DeleteQrTagMutationHookResult = ReturnType<typeof useDeleteQrTagMutation>;
export type DeleteQrTagMutationResult = Apollo.MutationResult<DeleteQrTagMutation>;
export type DeleteQrTagMutationOptions = Apollo.BaseMutationOptions<DeleteQrTagMutation, DeleteQrTagMutationVariables>;
export const ResendActivationMailDocument = gql`
    mutation resendActivationMail {
  resendActivationMail
}
    `;
export type ResendActivationMailMutationFn = Apollo.MutationFunction<ResendActivationMailMutation, ResendActivationMailMutationVariables>;

/**
 * __useResendActivationMailMutation__
 *
 * To run a mutation, you first call `useResendActivationMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendActivationMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendActivationMailMutation, { data, loading, error }] = useResendActivationMailMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendActivationMailMutation(baseOptions?: Apollo.MutationHookOptions<ResendActivationMailMutation, ResendActivationMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendActivationMailMutation, ResendActivationMailMutationVariables>(ResendActivationMailDocument, options);
      }
export type ResendActivationMailMutationHookResult = ReturnType<typeof useResendActivationMailMutation>;
export type ResendActivationMailMutationResult = Apollo.MutationResult<ResendActivationMailMutation>;
export type ResendActivationMailMutationOptions = Apollo.BaseMutationOptions<ResendActivationMailMutation, ResendActivationMailMutationVariables>;
export const InstagramPostsDocument = gql`
    query instagramPosts($after: String) {
  instagramPosts(after: $after) {
    next
    data {
      id
      media_url
    }
  }
}
    `;

/**
 * __useInstagramPostsQuery__
 *
 * To run a query within a React component, call `useInstagramPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstagramPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstagramPostsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInstagramPostsQuery(baseOptions?: Apollo.QueryHookOptions<InstagramPostsQuery, InstagramPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstagramPostsQuery, InstagramPostsQueryVariables>(InstagramPostsDocument, options);
      }
export function useInstagramPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstagramPostsQuery, InstagramPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstagramPostsQuery, InstagramPostsQueryVariables>(InstagramPostsDocument, options);
        }
export type InstagramPostsQueryHookResult = ReturnType<typeof useInstagramPostsQuery>;
export type InstagramPostsLazyQueryHookResult = ReturnType<typeof useInstagramPostsLazyQuery>;
export type InstagramPostsQueryResult = Apollo.QueryResult<InstagramPostsQuery, InstagramPostsQueryVariables>;
export const DeleteQrTemplateDocument = gql`
    mutation deleteQrTemplate($id: String!) {
  deleteQrTemplate(id: $id)
}
    `;
export type DeleteQrTemplateMutationFn = Apollo.MutationFunction<DeleteQrTemplateMutation, DeleteQrTemplateMutationVariables>;

/**
 * __useDeleteQrTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteQrTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQrTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQrTemplateMutation, { data, loading, error }] = useDeleteQrTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQrTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQrTemplateMutation, DeleteQrTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQrTemplateMutation, DeleteQrTemplateMutationVariables>(DeleteQrTemplateDocument, options);
      }
export type DeleteQrTemplateMutationHookResult = ReturnType<typeof useDeleteQrTemplateMutation>;
export type DeleteQrTemplateMutationResult = Apollo.MutationResult<DeleteQrTemplateMutation>;
export type DeleteQrTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteQrTemplateMutation, DeleteQrTemplateMutationVariables>;
export const CustomDomainsDocument = gql`
    query customDomains {
  customDomains {
    id
    domain
    errorPage
    usedInPage
  }
}
    `;

/**
 * __useCustomDomainsQuery__
 *
 * To run a query within a React component, call `useCustomDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomDomainsQuery(baseOptions?: Apollo.QueryHookOptions<CustomDomainsQuery, CustomDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomDomainsQuery, CustomDomainsQueryVariables>(CustomDomainsDocument, options);
      }
export function useCustomDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomDomainsQuery, CustomDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomDomainsQuery, CustomDomainsQueryVariables>(CustomDomainsDocument, options);
        }
export type CustomDomainsQueryHookResult = ReturnType<typeof useCustomDomainsQuery>;
export type CustomDomainsLazyQueryHookResult = ReturnType<typeof useCustomDomainsLazyQuery>;
export type CustomDomainsQueryResult = Apollo.QueryResult<CustomDomainsQuery, CustomDomainsQueryVariables>;
export const CreateDomainDocument = gql`
    mutation createDomain($data: CreateDomainInput!) {
  createDomain(data: $data) {
    id
    domain
    errorPage
    usedInPage
  }
}
    `;
export type CreateDomainMutationFn = Apollo.MutationFunction<CreateDomainMutation, CreateDomainMutationVariables>;

/**
 * __useCreateDomainMutation__
 *
 * To run a mutation, you first call `useCreateDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDomainMutation, { data, loading, error }] = useCreateDomainMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDomainMutation(baseOptions?: Apollo.MutationHookOptions<CreateDomainMutation, CreateDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDomainMutation, CreateDomainMutationVariables>(CreateDomainDocument, options);
      }
export type CreateDomainMutationHookResult = ReturnType<typeof useCreateDomainMutation>;
export type CreateDomainMutationResult = Apollo.MutationResult<CreateDomainMutation>;
export type CreateDomainMutationOptions = Apollo.BaseMutationOptions<CreateDomainMutation, CreateDomainMutationVariables>;
export const DeleteDomainDocument = gql`
    mutation deleteDomain($id: String!) {
  deleteDomain(domainId: $id)
}
    `;
export type DeleteDomainMutationFn = Apollo.MutationFunction<DeleteDomainMutation, DeleteDomainMutationVariables>;

/**
 * __useDeleteDomainMutation__
 *
 * To run a mutation, you first call `useDeleteDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDomainMutation, { data, loading, error }] = useDeleteDomainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDomainMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDomainMutation, DeleteDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDomainMutation, DeleteDomainMutationVariables>(DeleteDomainDocument, options);
      }
export type DeleteDomainMutationHookResult = ReturnType<typeof useDeleteDomainMutation>;
export type DeleteDomainMutationResult = Apollo.MutationResult<DeleteDomainMutation>;
export type DeleteDomainMutationOptions = Apollo.BaseMutationOptions<DeleteDomainMutation, DeleteDomainMutationVariables>;
export const InsightDocument = gql`
    query insight($type: InsightType!, $query: InsightDataQuery!, $id: String, $date: DateInterval) {
  insight(type: $type, query: $query, id: $id, date: $date) {
    id
    series {
      metricId
      serie {
        date
        count
        city
        state
        country
        day
        part
        os
        title
        device
        lat
        lon
      }
    }
    config
  }
}
    `;

/**
 * __useInsightQuery__
 *
 * To run a query within a React component, call `useInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightQuery({
 *   variables: {
 *      type: // value for 'type'
 *      query: // value for 'query'
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useInsightQuery(baseOptions: Apollo.QueryHookOptions<InsightQuery, InsightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightQuery, InsightQueryVariables>(InsightDocument, options);
      }
export function useInsightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightQuery, InsightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightQuery, InsightQueryVariables>(InsightDocument, options);
        }
export type InsightQueryHookResult = ReturnType<typeof useInsightQuery>;
export type InsightLazyQueryHookResult = ReturnType<typeof useInsightLazyQuery>;
export type InsightQueryResult = Apollo.QueryResult<InsightQuery, InsightQueryVariables>;
export const GetQrNamesDocument = gql`
    query getQrNames($limit: Int!, $offset: Int!, $category: [String!]) {
  getSingleLinks(limit: $limit, offset: $offset, category: $category) {
    nodes {
      id
      title
      categoryName
      singleLinkCategoryId
    }
  }
}
    `;

/**
 * __useGetQrNamesQuery__
 *
 * To run a query within a React component, call `useGetQrNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQrNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQrNamesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetQrNamesQuery(baseOptions: Apollo.QueryHookOptions<GetQrNamesQuery, GetQrNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQrNamesQuery, GetQrNamesQueryVariables>(GetQrNamesDocument, options);
      }
export function useGetQrNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQrNamesQuery, GetQrNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQrNamesQuery, GetQrNamesQueryVariables>(GetQrNamesDocument, options);
        }
export type GetQrNamesQueryHookResult = ReturnType<typeof useGetQrNamesQuery>;
export type GetQrNamesLazyQueryHookResult = ReturnType<typeof useGetQrNamesLazyQuery>;
export type GetQrNamesQueryResult = Apollo.QueryResult<GetQrNamesQuery, GetQrNamesQueryVariables>;
export const MePageDocument = gql`
    query MePage {
  me {
    page {
      ...Page
    }
  }
}
    ${PageFragmentDoc}`;

/**
 * __useMePageQuery__
 *
 * To run a query within a React component, call `useMePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useMePageQuery(baseOptions?: Apollo.QueryHookOptions<MePageQuery, MePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MePageQuery, MePageQueryVariables>(MePageDocument, options);
      }
export function useMePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MePageQuery, MePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MePageQuery, MePageQueryVariables>(MePageDocument, options);
        }
export type MePageQueryHookResult = ReturnType<typeof useMePageQuery>;
export type MePageLazyQueryHookResult = ReturnType<typeof useMePageLazyQuery>;
export type MePageQueryResult = Apollo.QueryResult<MePageQuery, MePageQueryVariables>;
export const SubscribersDocument = gql`
    query subscribers($offset: Int, $limit: Int, $type: String) {
  subscribers(offset: $offset, limit: $limit, type: $type) {
    subscriber {
      value
    }
    meta {
      count
    }
  }
}
    `;

/**
 * __useSubscribersQuery__
 *
 * To run a query within a React component, call `useSubscribersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscribersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSubscribersQuery(baseOptions?: Apollo.QueryHookOptions<SubscribersQuery, SubscribersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscribersQuery, SubscribersQueryVariables>(SubscribersDocument, options);
      }
export function useSubscribersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscribersQuery, SubscribersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscribersQuery, SubscribersQueryVariables>(SubscribersDocument, options);
        }
export type SubscribersQueryHookResult = ReturnType<typeof useSubscribersQuery>;
export type SubscribersLazyQueryHookResult = ReturnType<typeof useSubscribersLazyQuery>;
export type SubscribersQueryResult = Apollo.QueryResult<SubscribersQuery, SubscribersQueryVariables>;
export const MailchimpListsDocument = gql`
    query MailchimpLists($apiKey: String!) {
  mailchimpLists(api: $apiKey)
}
    `;

/**
 * __useMailchimpListsQuery__
 *
 * To run a query within a React component, call `useMailchimpListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailchimpListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailchimpListsQuery({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useMailchimpListsQuery(baseOptions: Apollo.QueryHookOptions<MailchimpListsQuery, MailchimpListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailchimpListsQuery, MailchimpListsQueryVariables>(MailchimpListsDocument, options);
      }
export function useMailchimpListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailchimpListsQuery, MailchimpListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailchimpListsQuery, MailchimpListsQueryVariables>(MailchimpListsDocument, options);
        }
export type MailchimpListsQueryHookResult = ReturnType<typeof useMailchimpListsQuery>;
export type MailchimpListsLazyQueryHookResult = ReturnType<typeof useMailchimpListsLazyQuery>;
export type MailchimpListsQueryResult = Apollo.QueryResult<MailchimpListsQuery, MailchimpListsQueryVariables>;
export const CreateLinkDocument = gql`
    mutation CreateLink($parent: String, $type: LinkType) {
  createPageLink(parent: $parent, type: $type) {
    ...Link
  }
}
    ${LinkFragmentDoc}`;
export type CreateLinkMutationFn = Apollo.MutationFunction<CreateLinkMutation, CreateLinkMutationVariables>;

/**
 * __useCreateLinkMutation__
 *
 * To run a mutation, you first call `useCreateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkMutation, { data, loading, error }] = useCreateLinkMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkMutation, CreateLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkMutation, CreateLinkMutationVariables>(CreateLinkDocument, options);
      }
export type CreateLinkMutationHookResult = ReturnType<typeof useCreateLinkMutation>;
export type CreateLinkMutationResult = Apollo.MutationResult<CreateLinkMutation>;
export type CreateLinkMutationOptions = Apollo.BaseMutationOptions<CreateLinkMutation, CreateLinkMutationVariables>;
export const CreateGridLinksDocument = gql`
    mutation CreateGridLinks($parent: String, $count: Int) {
  createGridLinks(parent: $parent, count: $count) {
    ...LinkProps
  }
}
    ${LinkPropsFragmentDoc}`;
export type CreateGridLinksMutationFn = Apollo.MutationFunction<CreateGridLinksMutation, CreateGridLinksMutationVariables>;

/**
 * __useCreateGridLinksMutation__
 *
 * To run a mutation, you first call `useCreateGridLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGridLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGridLinksMutation, { data, loading, error }] = useCreateGridLinksMutation({
 *   variables: {
 *      parent: // value for 'parent'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useCreateGridLinksMutation(baseOptions?: Apollo.MutationHookOptions<CreateGridLinksMutation, CreateGridLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGridLinksMutation, CreateGridLinksMutationVariables>(CreateGridLinksDocument, options);
      }
export type CreateGridLinksMutationHookResult = ReturnType<typeof useCreateGridLinksMutation>;
export type CreateGridLinksMutationResult = Apollo.MutationResult<CreateGridLinksMutation>;
export type CreateGridLinksMutationOptions = Apollo.BaseMutationOptions<CreateGridLinksMutation, CreateGridLinksMutationVariables>;
export const UpdateLinkModifierDocument = gql`
    mutation UpdateLinkModifier($data: UpdateLinkModifier!) {
  updateLinkModifier(data: $data) {
    ...Link
  }
}
    ${LinkFragmentDoc}`;
export type UpdateLinkModifierMutationFn = Apollo.MutationFunction<UpdateLinkModifierMutation, UpdateLinkModifierMutationVariables>;

/**
 * __useUpdateLinkModifierMutation__
 *
 * To run a mutation, you first call `useUpdateLinkModifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkModifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinkModifierMutation, { data, loading, error }] = useUpdateLinkModifierMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLinkModifierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinkModifierMutation, UpdateLinkModifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinkModifierMutation, UpdateLinkModifierMutationVariables>(UpdateLinkModifierDocument, options);
      }
export type UpdateLinkModifierMutationHookResult = ReturnType<typeof useUpdateLinkModifierMutation>;
export type UpdateLinkModifierMutationResult = Apollo.MutationResult<UpdateLinkModifierMutation>;
export type UpdateLinkModifierMutationOptions = Apollo.BaseMutationOptions<UpdateLinkModifierMutation, UpdateLinkModifierMutationVariables>;
export const UpdateLinksOrderDocument = gql`
    mutation UpdateLinksOrder($data: [UpdateLinkInputOrder!]!) {
  updateLinksOrder(data: $data) {
    id
    order
  }
}
    `;
export type UpdateLinksOrderMutationFn = Apollo.MutationFunction<UpdateLinksOrderMutation, UpdateLinksOrderMutationVariables>;

/**
 * __useUpdateLinksOrderMutation__
 *
 * To run a mutation, you first call `useUpdateLinksOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinksOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinksOrderMutation, { data, loading, error }] = useUpdateLinksOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLinksOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinksOrderMutation, UpdateLinksOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinksOrderMutation, UpdateLinksOrderMutationVariables>(UpdateLinksOrderDocument, options);
      }
export type UpdateLinksOrderMutationHookResult = ReturnType<typeof useUpdateLinksOrderMutation>;
export type UpdateLinksOrderMutationResult = Apollo.MutationResult<UpdateLinksOrderMutation>;
export type UpdateLinksOrderMutationOptions = Apollo.BaseMutationOptions<UpdateLinksOrderMutation, UpdateLinksOrderMutationVariables>;
export const UpdateLinkDocument = gql`
    mutation UpdateLink($data: UpdateLinkInput!) {
  updateLink(data: $data) {
    ...Link
  }
}
    ${LinkFragmentDoc}`;
export type UpdateLinkMutationFn = Apollo.MutationFunction<UpdateLinkMutation, UpdateLinkMutationVariables>;

/**
 * __useUpdateLinkMutation__
 *
 * To run a mutation, you first call `useUpdateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinkMutation, { data, loading, error }] = useUpdateLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinkMutation, UpdateLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinkMutation, UpdateLinkMutationVariables>(UpdateLinkDocument, options);
      }
export type UpdateLinkMutationHookResult = ReturnType<typeof useUpdateLinkMutation>;
export type UpdateLinkMutationResult = Apollo.MutationResult<UpdateLinkMutation>;
export type UpdateLinkMutationOptions = Apollo.BaseMutationOptions<UpdateLinkMutation, UpdateLinkMutationVariables>;
export const ApplyPromoDocument = gql`
    mutation ApplyPromo($data: String!) {
  applyPromoCode(data: $data)
}
    `;
export type ApplyPromoMutationFn = Apollo.MutationFunction<ApplyPromoMutation, ApplyPromoMutationVariables>;

/**
 * __useApplyPromoMutation__
 *
 * To run a mutation, you first call `useApplyPromoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyPromoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyPromoMutation, { data, loading, error }] = useApplyPromoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useApplyPromoMutation(baseOptions?: Apollo.MutationHookOptions<ApplyPromoMutation, ApplyPromoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyPromoMutation, ApplyPromoMutationVariables>(ApplyPromoDocument, options);
      }
export type ApplyPromoMutationHookResult = ReturnType<typeof useApplyPromoMutation>;
export type ApplyPromoMutationResult = Apollo.MutationResult<ApplyPromoMutation>;
export type ApplyPromoMutationOptions = Apollo.BaseMutationOptions<ApplyPromoMutation, ApplyPromoMutationVariables>;
export const DeleteLinkDocument = gql`
    mutation DeleteLink($data: DeleteLinkInput!) {
  deleteLink(data: $data) {
    id
  }
}
    `;
export type DeleteLinkMutationFn = Apollo.MutationFunction<DeleteLinkMutation, DeleteLinkMutationVariables>;

/**
 * __useDeleteLinkMutation__
 *
 * To run a mutation, you first call `useDeleteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLinkMutation, { data, loading, error }] = useDeleteLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLinkMutation, DeleteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLinkMutation, DeleteLinkMutationVariables>(DeleteLinkDocument, options);
      }
export type DeleteLinkMutationHookResult = ReturnType<typeof useDeleteLinkMutation>;
export type DeleteLinkMutationResult = Apollo.MutationResult<DeleteLinkMutation>;
export type DeleteLinkMutationOptions = Apollo.BaseMutationOptions<DeleteLinkMutation, DeleteLinkMutationVariables>;
export const UpdateAppearanceDocument = gql`
    mutation UpdateAppearance($data: AppearanceInput!) {
  updateAppearance(data: $data) {
    ...Appearance
  }
}
    ${AppearanceFragmentDoc}`;
export type UpdateAppearanceMutationFn = Apollo.MutationFunction<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>;

/**
 * __useUpdateAppearanceMutation__
 *
 * To run a mutation, you first call `useUpdateAppearanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppearanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppearanceMutation, { data, loading, error }] = useUpdateAppearanceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAppearanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>(UpdateAppearanceDocument, options);
      }
export type UpdateAppearanceMutationHookResult = ReturnType<typeof useUpdateAppearanceMutation>;
export type UpdateAppearanceMutationResult = Apollo.MutationResult<UpdateAppearanceMutation>;
export type UpdateAppearanceMutationOptions = Apollo.BaseMutationOptions<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>;
export const UpdateSettingsDocument = gql`
    mutation UpdateSettings($data: PageSettingsInput!) {
  updateSettings(data: $data) {
    ...Settings
  }
}
    ${SettingsFragmentDoc}`;
export type UpdateSettingsMutationFn = Apollo.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const CreateQrDocument = gql`
    mutation CreateQr($data: QrInput!) {
  createQr(data: $data) {
    ...Qr
  }
}
    ${QrFragmentDoc}`;
export type CreateQrMutationFn = Apollo.MutationFunction<CreateQrMutation, CreateQrMutationVariables>;

/**
 * __useCreateQrMutation__
 *
 * To run a mutation, you first call `useCreateQrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQrMutation, { data, loading, error }] = useCreateQrMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQrMutation(baseOptions?: Apollo.MutationHookOptions<CreateQrMutation, CreateQrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQrMutation, CreateQrMutationVariables>(CreateQrDocument, options);
      }
export type CreateQrMutationHookResult = ReturnType<typeof useCreateQrMutation>;
export type CreateQrMutationResult = Apollo.MutationResult<CreateQrMutation>;
export type CreateQrMutationOptions = Apollo.BaseMutationOptions<CreateQrMutation, CreateQrMutationVariables>;
export const UpdatePageDomainDocument = gql`
    mutation UpdatePageDomain($domainId: String, $pageId: String!) {
  updatePageDomain(domainId: $domainId, pageId: $pageId) {
    id
  }
}
    `;
export type UpdatePageDomainMutationFn = Apollo.MutationFunction<UpdatePageDomainMutation, UpdatePageDomainMutationVariables>;

/**
 * __useUpdatePageDomainMutation__
 *
 * To run a mutation, you first call `useUpdatePageDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageDomainMutation, { data, loading, error }] = useUpdatePageDomainMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useUpdatePageDomainMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageDomainMutation, UpdatePageDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageDomainMutation, UpdatePageDomainMutationVariables>(UpdatePageDomainDocument, options);
      }
export type UpdatePageDomainMutationHookResult = ReturnType<typeof useUpdatePageDomainMutation>;
export type UpdatePageDomainMutationResult = Apollo.MutationResult<UpdatePageDomainMutation>;
export type UpdatePageDomainMutationOptions = Apollo.BaseMutationOptions<UpdatePageDomainMutation, UpdatePageDomainMutationVariables>;
export const DeleteEmailSubscriberDocument = gql`
    mutation deleteEmailSubscriber($data: DeleteEmailSubscriber!) {
  deleteEmailSubscriber(data: $data)
}
    `;
export type DeleteEmailSubscriberMutationFn = Apollo.MutationFunction<DeleteEmailSubscriberMutation, DeleteEmailSubscriberMutationVariables>;

/**
 * __useDeleteEmailSubscriberMutation__
 *
 * To run a mutation, you first call `useDeleteEmailSubscriberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailSubscriberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailSubscriberMutation, { data, loading, error }] = useDeleteEmailSubscriberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteEmailSubscriberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailSubscriberMutation, DeleteEmailSubscriberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailSubscriberMutation, DeleteEmailSubscriberMutationVariables>(DeleteEmailSubscriberDocument, options);
      }
export type DeleteEmailSubscriberMutationHookResult = ReturnType<typeof useDeleteEmailSubscriberMutation>;
export type DeleteEmailSubscriberMutationResult = Apollo.MutationResult<DeleteEmailSubscriberMutation>;
export type DeleteEmailSubscriberMutationOptions = Apollo.BaseMutationOptions<DeleteEmailSubscriberMutation, DeleteEmailSubscriberMutationVariables>;
export const GetSingleLinksDocument = gql`
    query getSingleLinks($limit: Int!, $offset: Int!, $category: [String!], $search: String, $filter: String) {
  getSingleLinks(
    limit: $limit
    offset: $offset
    category: $category
    search: $search
    filter: $filter
  ) {
    totalCount
    nodes {
      id
      createdAt
      hash
      url
      title
      scans
      categoryName
      domainId
      singleLinkCategoryId
      type
      isPassive
      qr {
        ...QrSingleLink
      }
    }
  }
}
    ${QrSingleLinkFragmentDoc}`;

/**
 * __useGetSingleLinksQuery__
 *
 * To run a query within a React component, call `useGetSingleLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleLinksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      category: // value for 'category'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSingleLinksQuery(baseOptions: Apollo.QueryHookOptions<GetSingleLinksQuery, GetSingleLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleLinksQuery, GetSingleLinksQueryVariables>(GetSingleLinksDocument, options);
      }
export function useGetSingleLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleLinksQuery, GetSingleLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleLinksQuery, GetSingleLinksQueryVariables>(GetSingleLinksDocument, options);
        }
export type GetSingleLinksQueryHookResult = ReturnType<typeof useGetSingleLinksQuery>;
export type GetSingleLinksLazyQueryHookResult = ReturnType<typeof useGetSingleLinksLazyQuery>;
export type GetSingleLinksQueryResult = Apollo.QueryResult<GetSingleLinksQuery, GetSingleLinksQueryVariables>;
export const GetSingleLinkDocument = gql`
    query getSingleLink($id: String!) {
  getSingleLink(id: $id) {
    id
    createdAt
    hash
    url
    title
    categoryName
    singleLinkCategoryId
    password
    domainId
    type
    isPassive
    target {
      platform
      channel
      audience
      campaign
      creative
      vendor
    }
    qr {
      ...QrSingleLink
    }
  }
}
    ${QrSingleLinkFragmentDoc}`;

/**
 * __useGetSingleLinkQuery__
 *
 * To run a query within a React component, call `useGetSingleLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleLinkQuery(baseOptions: Apollo.QueryHookOptions<GetSingleLinkQuery, GetSingleLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleLinkQuery, GetSingleLinkQueryVariables>(GetSingleLinkDocument, options);
      }
export function useGetSingleLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleLinkQuery, GetSingleLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleLinkQuery, GetSingleLinkQueryVariables>(GetSingleLinkDocument, options);
        }
export type GetSingleLinkQueryHookResult = ReturnType<typeof useGetSingleLinkQuery>;
export type GetSingleLinkLazyQueryHookResult = ReturnType<typeof useGetSingleLinkLazyQuery>;
export type GetSingleLinkQueryResult = Apollo.QueryResult<GetSingleLinkQuery, GetSingleLinkQueryVariables>;
export const GetSingleLinksForFilterDocument = gql`
    query getSingleLinksForFilter($category: [String!]) {
  filterLinks: getSingleLinks(category: $category) {
    nodes {
      id
      title
      singleLinkCategoryId
    }
  }
}
    `;

/**
 * __useGetSingleLinksForFilterQuery__
 *
 * To run a query within a React component, call `useGetSingleLinksForFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleLinksForFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleLinksForFilterQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetSingleLinksForFilterQuery(baseOptions?: Apollo.QueryHookOptions<GetSingleLinksForFilterQuery, GetSingleLinksForFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleLinksForFilterQuery, GetSingleLinksForFilterQueryVariables>(GetSingleLinksForFilterDocument, options);
      }
export function useGetSingleLinksForFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleLinksForFilterQuery, GetSingleLinksForFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleLinksForFilterQuery, GetSingleLinksForFilterQueryVariables>(GetSingleLinksForFilterDocument, options);
        }
export type GetSingleLinksForFilterQueryHookResult = ReturnType<typeof useGetSingleLinksForFilterQuery>;
export type GetSingleLinksForFilterLazyQueryHookResult = ReturnType<typeof useGetSingleLinksForFilterLazyQuery>;
export type GetSingleLinksForFilterQueryResult = Apollo.QueryResult<GetSingleLinksForFilterQuery, GetSingleLinksForFilterQueryVariables>;
export const CreateTmpSingleLinkDocument = gql`
    query createTmpSingleLink {
  createTmpSingleLink {
    id
    title
    url
    hash
    isPassive
    singleLinkCategoryId
    target {
      platform
      channel
      audience
      campaign
      creative
      vendor
    }
  }
}
    `;

/**
 * __useCreateTmpSingleLinkQuery__
 *
 * To run a query within a React component, call `useCreateTmpSingleLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateTmpSingleLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateTmpSingleLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateTmpSingleLinkQuery(baseOptions?: Apollo.QueryHookOptions<CreateTmpSingleLinkQuery, CreateTmpSingleLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateTmpSingleLinkQuery, CreateTmpSingleLinkQueryVariables>(CreateTmpSingleLinkDocument, options);
      }
export function useCreateTmpSingleLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateTmpSingleLinkQuery, CreateTmpSingleLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateTmpSingleLinkQuery, CreateTmpSingleLinkQueryVariables>(CreateTmpSingleLinkDocument, options);
        }
export type CreateTmpSingleLinkQueryHookResult = ReturnType<typeof useCreateTmpSingleLinkQuery>;
export type CreateTmpSingleLinkLazyQueryHookResult = ReturnType<typeof useCreateTmpSingleLinkLazyQuery>;
export type CreateTmpSingleLinkQueryResult = Apollo.QueryResult<CreateTmpSingleLinkQuery, CreateTmpSingleLinkQueryVariables>;
export const SingleLinkCategoriesDocument = gql`
    query singleLinkCategories {
  categories {
    id
    name
    linksCount
  }
}
    `;

/**
 * __useSingleLinkCategoriesQuery__
 *
 * To run a query within a React component, call `useSingleLinkCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleLinkCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleLinkCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSingleLinkCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<SingleLinkCategoriesQuery, SingleLinkCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleLinkCategoriesQuery, SingleLinkCategoriesQueryVariables>(SingleLinkCategoriesDocument, options);
      }
export function useSingleLinkCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleLinkCategoriesQuery, SingleLinkCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleLinkCategoriesQuery, SingleLinkCategoriesQueryVariables>(SingleLinkCategoriesDocument, options);
        }
export type SingleLinkCategoriesQueryHookResult = ReturnType<typeof useSingleLinkCategoriesQuery>;
export type SingleLinkCategoriesLazyQueryHookResult = ReturnType<typeof useSingleLinkCategoriesLazyQuery>;
export type SingleLinkCategoriesQueryResult = Apollo.QueryResult<SingleLinkCategoriesQuery, SingleLinkCategoriesQueryVariables>;
export const SingleLinkCategoryDocument = gql`
    query singleLinkCategory($id: String!) {
  category(id: $id) {
    id
    name
    linksCount
    scans
  }
}
    `;

/**
 * __useSingleLinkCategoryQuery__
 *
 * To run a query within a React component, call `useSingleLinkCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleLinkCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleLinkCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleLinkCategoryQuery(baseOptions: Apollo.QueryHookOptions<SingleLinkCategoryQuery, SingleLinkCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleLinkCategoryQuery, SingleLinkCategoryQueryVariables>(SingleLinkCategoryDocument, options);
      }
export function useSingleLinkCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleLinkCategoryQuery, SingleLinkCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleLinkCategoryQuery, SingleLinkCategoryQueryVariables>(SingleLinkCategoryDocument, options);
        }
export type SingleLinkCategoryQueryHookResult = ReturnType<typeof useSingleLinkCategoryQuery>;
export type SingleLinkCategoryLazyQueryHookResult = ReturnType<typeof useSingleLinkCategoryLazyQuery>;
export type SingleLinkCategoryQueryResult = Apollo.QueryResult<SingleLinkCategoryQuery, SingleLinkCategoryQueryVariables>;
export const SingleLinkCategoryLinksDocument = gql`
    query singleLinkCategoryLinks($id: String!) {
  category(id: $id) {
    id
    links {
      id
      title
    }
  }
}
    `;

/**
 * __useSingleLinkCategoryLinksQuery__
 *
 * To run a query within a React component, call `useSingleLinkCategoryLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleLinkCategoryLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleLinkCategoryLinksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleLinkCategoryLinksQuery(baseOptions: Apollo.QueryHookOptions<SingleLinkCategoryLinksQuery, SingleLinkCategoryLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleLinkCategoryLinksQuery, SingleLinkCategoryLinksQueryVariables>(SingleLinkCategoryLinksDocument, options);
      }
export function useSingleLinkCategoryLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleLinkCategoryLinksQuery, SingleLinkCategoryLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleLinkCategoryLinksQuery, SingleLinkCategoryLinksQueryVariables>(SingleLinkCategoryLinksDocument, options);
        }
export type SingleLinkCategoryLinksQueryHookResult = ReturnType<typeof useSingleLinkCategoryLinksQuery>;
export type SingleLinkCategoryLinksLazyQueryHookResult = ReturnType<typeof useSingleLinkCategoryLinksLazyQuery>;
export type SingleLinkCategoryLinksQueryResult = Apollo.QueryResult<SingleLinkCategoryLinksQuery, SingleLinkCategoryLinksQueryVariables>;
export const QrTemplatesDocument = gql`
    query qrTemplates {
  qrTemplates {
    id
    appearance
  }
}
    `;

/**
 * __useQrTemplatesQuery__
 *
 * To run a query within a React component, call `useQrTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQrTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQrTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useQrTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<QrTemplatesQuery, QrTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QrTemplatesQuery, QrTemplatesQueryVariables>(QrTemplatesDocument, options);
      }
export function useQrTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QrTemplatesQuery, QrTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QrTemplatesQuery, QrTemplatesQueryVariables>(QrTemplatesDocument, options);
        }
export type QrTemplatesQueryHookResult = ReturnType<typeof useQrTemplatesQuery>;
export type QrTemplatesLazyQueryHookResult = ReturnType<typeof useQrTemplatesLazyQuery>;
export type QrTemplatesQueryResult = Apollo.QueryResult<QrTemplatesQuery, QrTemplatesQueryVariables>;
export const CreateQrTemplateDocument = gql`
    mutation createQrTemplate($data: QrTemplateInput!) {
  createQrTemplate(data: $data) {
    id
    appearance
  }
}
    `;
export type CreateQrTemplateMutationFn = Apollo.MutationFunction<CreateQrTemplateMutation, CreateQrTemplateMutationVariables>;

/**
 * __useCreateQrTemplateMutation__
 *
 * To run a mutation, you first call `useCreateQrTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQrTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQrTemplateMutation, { data, loading, error }] = useCreateQrTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQrTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateQrTemplateMutation, CreateQrTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQrTemplateMutation, CreateQrTemplateMutationVariables>(CreateQrTemplateDocument, options);
      }
export type CreateQrTemplateMutationHookResult = ReturnType<typeof useCreateQrTemplateMutation>;
export type CreateQrTemplateMutationResult = Apollo.MutationResult<CreateQrTemplateMutation>;
export type CreateQrTemplateMutationOptions = Apollo.BaseMutationOptions<CreateQrTemplateMutation, CreateQrTemplateMutationVariables>;
export const CreateSingleLinkCategoryDocument = gql`
    mutation createSingleLinkCategory($data: SingleLinkCategoryInput!) {
  createSingleLinkCategory(data: $data) {
    id
    name
  }
}
    `;
export type CreateSingleLinkCategoryMutationFn = Apollo.MutationFunction<CreateSingleLinkCategoryMutation, CreateSingleLinkCategoryMutationVariables>;

/**
 * __useCreateSingleLinkCategoryMutation__
 *
 * To run a mutation, you first call `useCreateSingleLinkCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSingleLinkCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSingleLinkCategoryMutation, { data, loading, error }] = useCreateSingleLinkCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSingleLinkCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateSingleLinkCategoryMutation, CreateSingleLinkCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSingleLinkCategoryMutation, CreateSingleLinkCategoryMutationVariables>(CreateSingleLinkCategoryDocument, options);
      }
export type CreateSingleLinkCategoryMutationHookResult = ReturnType<typeof useCreateSingleLinkCategoryMutation>;
export type CreateSingleLinkCategoryMutationResult = Apollo.MutationResult<CreateSingleLinkCategoryMutation>;
export type CreateSingleLinkCategoryMutationOptions = Apollo.BaseMutationOptions<CreateSingleLinkCategoryMutation, CreateSingleLinkCategoryMutationVariables>;
export const UpdateSingleLinkCategoryDocument = gql`
    mutation updateSingleLinkCategory($data: SingleLinkCategoryUpdate!) {
  updateSingleLinkCategory(data: $data) {
    id
    name
  }
}
    `;
export type UpdateSingleLinkCategoryMutationFn = Apollo.MutationFunction<UpdateSingleLinkCategoryMutation, UpdateSingleLinkCategoryMutationVariables>;

/**
 * __useUpdateSingleLinkCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateSingleLinkCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSingleLinkCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSingleLinkCategoryMutation, { data, loading, error }] = useUpdateSingleLinkCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSingleLinkCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSingleLinkCategoryMutation, UpdateSingleLinkCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSingleLinkCategoryMutation, UpdateSingleLinkCategoryMutationVariables>(UpdateSingleLinkCategoryDocument, options);
      }
export type UpdateSingleLinkCategoryMutationHookResult = ReturnType<typeof useUpdateSingleLinkCategoryMutation>;
export type UpdateSingleLinkCategoryMutationResult = Apollo.MutationResult<UpdateSingleLinkCategoryMutation>;
export type UpdateSingleLinkCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateSingleLinkCategoryMutation, UpdateSingleLinkCategoryMutationVariables>;
export const UpdateSingleLinkDocument = gql`
    mutation updateSingleLink($data: SingleLinkInput!) {
  updateSingleLink(data: $data) {
    id
    title
    url
    hash
    singleLinkCategoryId
    categoryName
    target {
      platform
      channel
      audience
      campaign
      creative
      vendor
    }
    qr {
      ...QrSingleLink
    }
  }
}
    ${QrSingleLinkFragmentDoc}`;
export type UpdateSingleLinkMutationFn = Apollo.MutationFunction<UpdateSingleLinkMutation, UpdateSingleLinkMutationVariables>;

/**
 * __useUpdateSingleLinkMutation__
 *
 * To run a mutation, you first call `useUpdateSingleLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSingleLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSingleLinkMutation, { data, loading, error }] = useUpdateSingleLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSingleLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSingleLinkMutation, UpdateSingleLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSingleLinkMutation, UpdateSingleLinkMutationVariables>(UpdateSingleLinkDocument, options);
      }
export type UpdateSingleLinkMutationHookResult = ReturnType<typeof useUpdateSingleLinkMutation>;
export type UpdateSingleLinkMutationResult = Apollo.MutationResult<UpdateSingleLinkMutation>;
export type UpdateSingleLinkMutationOptions = Apollo.BaseMutationOptions<UpdateSingleLinkMutation, UpdateSingleLinkMutationVariables>;
export const RemoveSingleLinkFromCategoryDocument = gql`
    mutation removeSingleLinkFromCategory($id: String!) {
  removeSingleLinkFromCategory(id: $id) {
    id
    singleLinkCategoryId
  }
}
    `;
export type RemoveSingleLinkFromCategoryMutationFn = Apollo.MutationFunction<RemoveSingleLinkFromCategoryMutation, RemoveSingleLinkFromCategoryMutationVariables>;

/**
 * __useRemoveSingleLinkFromCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveSingleLinkFromCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSingleLinkFromCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSingleLinkFromCategoryMutation, { data, loading, error }] = useRemoveSingleLinkFromCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSingleLinkFromCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSingleLinkFromCategoryMutation, RemoveSingleLinkFromCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSingleLinkFromCategoryMutation, RemoveSingleLinkFromCategoryMutationVariables>(RemoveSingleLinkFromCategoryDocument, options);
      }
export type RemoveSingleLinkFromCategoryMutationHookResult = ReturnType<typeof useRemoveSingleLinkFromCategoryMutation>;
export type RemoveSingleLinkFromCategoryMutationResult = Apollo.MutationResult<RemoveSingleLinkFromCategoryMutation>;
export type RemoveSingleLinkFromCategoryMutationOptions = Apollo.BaseMutationOptions<RemoveSingleLinkFromCategoryMutation, RemoveSingleLinkFromCategoryMutationVariables>;
export const DeleteSingleLinkDocument = gql`
    mutation deleteSingleLink($id: String!) {
  deleteSingleLink(id: $id)
}
    `;
export type DeleteSingleLinkMutationFn = Apollo.MutationFunction<DeleteSingleLinkMutation, DeleteSingleLinkMutationVariables>;

/**
 * __useDeleteSingleLinkMutation__
 *
 * To run a mutation, you first call `useDeleteSingleLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSingleLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSingleLinkMutation, { data, loading, error }] = useDeleteSingleLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSingleLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSingleLinkMutation, DeleteSingleLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSingleLinkMutation, DeleteSingleLinkMutationVariables>(DeleteSingleLinkDocument, options);
      }
export type DeleteSingleLinkMutationHookResult = ReturnType<typeof useDeleteSingleLinkMutation>;
export type DeleteSingleLinkMutationResult = Apollo.MutationResult<DeleteSingleLinkMutation>;
export type DeleteSingleLinkMutationOptions = Apollo.BaseMutationOptions<DeleteSingleLinkMutation, DeleteSingleLinkMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation deleteCategory($id: String!) {
  deleteCategory(id: $id)
}
    `;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const GetTargetsDocument = gql`
    query getTargets {
  targets: singleLinkTargets {
    platform {
      ...TargetsProps
    }
    channel {
      ...TargetsProps
    }
    audience {
      ...TargetsProps
    }
    campaign {
      ...TargetsProps
    }
    creative {
      ...TargetsProps
    }
    vendor {
      ...TargetsProps
    }
  }
}
    ${TargetsPropsFragmentDoc}`;

/**
 * __useGetTargetsQuery__
 *
 * To run a query within a React component, call `useGetTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTargetsQuery(baseOptions?: Apollo.QueryHookOptions<GetTargetsQuery, GetTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetsQuery, GetTargetsQueryVariables>(GetTargetsDocument, options);
      }
export function useGetTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetsQuery, GetTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetsQuery, GetTargetsQueryVariables>(GetTargetsDocument, options);
        }
export type GetTargetsQueryHookResult = ReturnType<typeof useGetTargetsQuery>;
export type GetTargetsLazyQueryHookResult = ReturnType<typeof useGetTargetsLazyQuery>;
export type GetTargetsQueryResult = Apollo.QueryResult<GetTargetsQuery, GetTargetsQueryVariables>;
export const CreateSingleLinkTargetDocument = gql`
    mutation createSingleLinkTarget($data: SingleLinkTargetInput!) {
  createSingleLinkTarget(data: $data) {
    id
    name
    type
  }
}
    `;
export type CreateSingleLinkTargetMutationFn = Apollo.MutationFunction<CreateSingleLinkTargetMutation, CreateSingleLinkTargetMutationVariables>;

/**
 * __useCreateSingleLinkTargetMutation__
 *
 * To run a mutation, you first call `useCreateSingleLinkTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSingleLinkTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSingleLinkTargetMutation, { data, loading, error }] = useCreateSingleLinkTargetMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSingleLinkTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreateSingleLinkTargetMutation, CreateSingleLinkTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSingleLinkTargetMutation, CreateSingleLinkTargetMutationVariables>(CreateSingleLinkTargetDocument, options);
      }
export type CreateSingleLinkTargetMutationHookResult = ReturnType<typeof useCreateSingleLinkTargetMutation>;
export type CreateSingleLinkTargetMutationResult = Apollo.MutationResult<CreateSingleLinkTargetMutation>;
export type CreateSingleLinkTargetMutationOptions = Apollo.BaseMutationOptions<CreateSingleLinkTargetMutation, CreateSingleLinkTargetMutationVariables>;